[
  {
    "key": "txt_DRIVER_MOD_SCORE",
    "text": "Driver Wellbeing Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة بُعد رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txt_DRIVER/IM_469",
    "text": "Impact / Dimension",
    "translations": [
      {
        "language": "AR",
        "text": "التأثير / البُعد"
      },
      {
        "language": "EN",
        "text": "Impact / Dimension"
      }
    ]
  },
  {
    "key": "ap_module_score",
    "text": "Wellbeing Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الرفاهية"
      }
    ]
  },
  {
    "key": "txtScore",
    "text": "Score",
    "translations": [
      {
        "language": "AR",
        "text": "النتيجة"
      }
    ]
  },
  {
    "key": "txt_AllDimens_652",
    "text": "All Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "كل الأبعاد"
      }
    ]
  },
  {
    "key": "txt_Dimension_544",
    "text": "Dimension: <span class=\"\"font-medium text-zen-primaryDark\">{{0}}</span>",
    "translations": [
      {
        "language": "AR",
        "text": "البُعد: <span class=\"\"font-medium text-zen-primaryDark\">{{0}}</span>"
      }
    ]
  },
  {
    "key": "txt_OverallEm_279",
    "text": "Overall Employee Wellbeing Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية لرفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtID",
    "text": "ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      }
    ]
  },
  {
    "key": "txt_Workplace_690",
    "text": "Workplace Wellbeing Scores",
    "translations": [
      {
        "language": "AR",
        "text": "درجات الرفاهية في مكان العمل"
      }
    ]
  },
  {
    "key": "ORG_POS_MeanScore",
    "text": "Team Wellbeing Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة رفاهية الفريق"
      }
    ]
  },
  {
    "key": "txt_Dimension_880",
    "text": "Dimension Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة البُعد"
      }
    ]
  },
  {
    "key": "txtWorkplaceWellbeingScore",
    "text": "Workplace Wellbeing Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الرفاهية في مكان العمل"
      }
    ]
  },
  {
    "key": "CompanyMeanScore",
    "text": "Company Avg.",
    "translations": [
      {
        "language": "AR",
        "text": "متوسط الشركة"
      }
    ]
  },
  {
    "key": "txtOverallScore",
    "text": "Overall Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية"
      }
    ]
  },
  {
    "key": "txt_Orchart_440",
    "text": "Org Chart",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      }
    ]
  },
  {
    "key": "ap_by_driver",
    "text": "By Dimension",
    "translations": [
      {
        "language": "AR",
        "text": "حسب البُعد"
      }
    ]
  },
  {
    "key": "ap_for_survey",
    "text": "For Wellbeing Survey:",
    "translations": [
      {
        "language": "AR",
        "text": "لـ استبيان الرفاهية:"
      }
    ]
  },
  {
    "key": "ap_section",
    "text": "Dimension",
    "translations": [
      {
        "language": "AR",
        "text": "البُعد"
      }
    ]
  },
  {
    "key": "txt_ActionPla_663",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "txt_drivers",
    "text": "Dimension",
    "translations": [
      {
        "language": "AR",
        "text": "البُعد"
      }
    ]
  },
  {
    "key": "txt_Responden_295",
    "text": "Respondent updated successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديث المستجيبين بنجاح"
      }
    ]
  },
  {
    "key": "txt_select_respondents",
    "text": "Select Respondents to send reminders",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المستجيبين لإرسال التذكيرات"
      }
    ]
  },
  {
    "key": "JOD",
    "text": "Joining date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانضمام"
      }
    ]
  },
  {
    "key": "DOB",
    "text": "Date of Birth",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الميلاد"
      }
    ]
  },
  {
    "key": "txt_Workplace_591",
    "text": "Workplace Well-being By",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية مكان العمل حسب"
      }
    ]
  },
  {
    "key": "txt_export_tb",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      }
    ]
  },
  {
    "key": "btnExport",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "txt_Customize_416",
    "text": "Customize the invitation email template or use the default template generated by Zenithr.<br> Hint: Do not erase the survey link. If erased, click on the default button.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل الدعوة او استخدم النموذج الأساسي المُعرف من  زينثر. <br> ملحوظة: لا تقم بمسح رابط الاستبيان. إذا تم مسحه، انقر على <b>\"النموذج الأساسي\"</b>."
      }
    ]
  },
  {
    "key": "txt_Youcanexp_908",
    "text": "You can export the comparison charts as per the current view. </br> Note: Available in PDF format",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل الرسوم البيانية للمقارنة وفقًا للعرض الحالي.</br> ملحوظة: متوفر في صيغة PDF. "
      }
    ]
  },
  {
    "key": "txt_Selectthe_788",
    "text": "Select the companies (if any) you want to compare. </br>Hint: if you have multiple surveys, you have the option to view average scores or select surveys for a tailored analysis! ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحديد الشركات (إن وُجد) التي ترغب في مقارنتها. </br>تلميح: إذا كانت لديك استبيانات متعددة، يُتاح لك خيار عرض متوسط الدرجات أو تحديد الاستبيانات التي ترغب في مقارنتها للحصول على تحليل مخصص. "
      }
    ]
  },
  {
    "key": "txt_Companies_799",
    "text": "Companies ",
    "translations": [
      {
        "language": "AR",
        "text": "الشركات "
      }
    ]
  },
  {
    "key": "txt_Selectthe_681",
    "text": "Select the start and end dates to view the analysis for a specific timeframe. ",
    "translations": [
      {
        "language": "AR",
        "text": "لعرض نتائج رفاهية الموظف لفترة زمنية معينة، قم باختيار تواريخ البداية والنهاية. "
      }
    ]
  },
  {
    "key": "txtComparison_wellbeing",
    "text": "Ready to uncover your survey history's top well-being scores and compare them across years and companies (if any)? Discover the answer now! ",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت مستعد للكشف عن أعلى نتائج رفاهية الموظف ومقارنتها عبر السنوات والشركات الخاصة بك (إن وُجد)؟ اكتشف الإجابة الآن! "
      }
    ]
  },
  {
    "key": "txt_Compariso_275",
    "text": "Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة "
      }
    ]
  },
  {
    "key": "txt_Changethe_415",
    "text": "Change the type of the chart by clicking here.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتغيير نوع الرسم البياني بالضغط هنا."
      }
    ]
  },
  {
    "key": "txt_Clickhere_159",
    "text": "Click here to download all comments.</br>Note: Available in Excel format ",
    "translations": [
      {
        "language": "AR",
        "text": "انقرهنا لتحميل جميع التعليقات. </br> ملحوظة: متوفر في صيغة Excel. "
      }
    ]
  },
  {
    "key": "txtComments_desc",
    "text": "Unlock the magic of AI with sentiment analysis in <b>“Comments”</b> – witness the power of your respondents’ feedback! ",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف سحر الذكاء الصناعي من خلال تحليل المشاعر والآراء في <b>\"التعليقات\"</b> - شاهد قوة تعليقات المستجيبين!"
      }
    ]
  },
  {
    "key": "txt_Expandthe_792",
    "text": "Expand the dimension to view each statement score and the distribution of respondents’ answers. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على البُعد لعرض متوسط كل عبارة وتوزيع إجابات المستجيبين. "
      }
    ]
  },
  {
    "key": "txt_Statement_817",
    "text": "Statements Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة العبارات "
      }
    ]
  },
  {
    "key": "txt_questions_desc",
    "text": "In \"Statements\", each dimension's score with its corresponding statement is shown. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"العبارات\"</b>، يتم عرض متوسط كل بُعد مع العبارات الخاصة به."
      }
    ]
  },
  {
    "key": "txt_ChartType_839",
    "text": "Chart Type ",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الرسم البياني "
      }
    ]
  },
  {
    "key": "txtResponses_desc",
    "text": "In <b>“Respondent Analysis”</b>, the charts shown depend on the analytical criteria selected in the survey setup step. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"تحليل المستجيبون\"</b> تعتمد الرسوم البيانية المعروضة على المعايير التحليلية المخُتارة في خطوة إعداد الاستبيان."
      }
    ]
  },
  {
    "key": "txt_Elevateyo_771",
    "text": "Elevate your insights with a click – download your heatmap! <br><br>Note: Available in Excel format",
    "translations": [
      {
        "language": "AR",
        "text": "ارفع مستوى التحليلات بنقرة واحدة - قم بتحميل مخطط تمثيل البيانات بالألوان الخاصة بك!<br><br>ملحوظة: متوفرة في صيغة Excel."
      }
    ]
  },
  {
    "key": "txt_ExpandDim_862",
    "text": "Expand Dimensions ",
    "translations": [
      {
        "language": "AR",
        "text": "عرض العوامل"
      }
    ]
  },
  {
    "key": "txt_Clickonea_896",
    "text": "Click on each Dimension to expand the results of their statements. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على كل بُعد لعرض نتائج العبارات الخاصة بهم. "
      }
    ]
  },
  {
    "key": "txt_Discovert_892",
    "text": "Discover the survey's highlights and insights in a summarized analysis! Compare the %difference between the overall score and dimensions & statements to demographics and custom criteria by selecting from the breakout dropdown. ",
    "translations": [
      {
        "language": "AR",
        "text": "   اكتشف أبرز نقاط التحليلات المُفصّلة في تحليل مُلخص! قارن الفرق في النسب بين درجة رفاهية الموظف الكلية والأبعاد والعبارات بالنسبة إلى الجوانب الديموغرافية والمعايير المخصصة وذلك من خلال من خلال الاختيار من القائمة المنسدلة. "
      }
    ]
  },
  {
    "key": "txt_Unlockthe_743",
    "text": "Unlock the power of your preferences! Revisit the criteria you chose in the survey setup and experience an analysis tailored to your specifications! <br><br>Hint: The system is interactive. Click on the chart legend to turn on/off options and have a clearer view of the results.<br/><img class=\"mt-2\" src=\"assets/img/tours/wb-wellbeing.gif\" />",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف قوة تحليلات زينيثر مع اختياراتك في إعدادات الاستبيان! استمتع بتجربة مصممة ومفصّلة وفق مواصفاتك! <br><br>تلميح: النظام تفاعلي. انقر على مفتاح الرسم البياني لتفعيل/إيقاف الخيارات والحصول على رؤية أوضح للنتائج.<br/><img class=\"mt-2\" src=\"assets/img/tours/wb-wellbeing.gif\" />"
      }
    ]
  },
  {
    "key": "txt_Workplace_851",
    "text": "Workplace Well-being ",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية مكان العمل "
      }
    ]
  },
  {
    "key": "txt_Clickhere_702",
    "text": "Click here to download the report and turn on the sections you want to include. </br>Hint: Easily access detailed entity reports by choosing your preferred entity type in the 'View by' menu and start downloading now!  - Available in PDF.\" ",
    "translations": [
      {
        "language": "AR",
        "text": " انقر هنا لتحميل التقرير واختر الأقسام التي ترغب في تضمينها في التقرير. </br>تلميح: قم بالوصول بسهولة إلى تقارير الوحدات التنظيمية المفصلة عن طريق اختيار نوع الوحدة التنظيمية في قائمة <b>\"تصفح عن طريق\"</b> وابدأ بالتحميل الآن! - متوفر في صيغة PDF."
      }
    ]
  },
  {
    "key": "txt_Clickhere_662",
    "text": "Click here to filter the analysis by choosing the entity.</br> Note: The number of respondents must be at least 3 to view the analysis of each entity. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض التحليلات عن طريق اختيار الوحدة التنظيمية. </br>ملحوظة: يجب ألا يقل عدد المستجيبين عن 3 لعرض تحليلات كل وحدة تنظيمية مختارة. "
      }
    ]
  },
  {
    "key": "txtOverview_desc",
    "text": "The <b>“Overview”</b> page shows the employee well-being scores, detailed comparison, and other valuable insights.  ",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة <b>“نظرة عامة”</b> تعرض نتائج رفاهية الموظف وتحليل القراءات والبيانات بشكل مفصّل ومعمّق."
      }
    ]
  },
  {
    "key": "txt_step_4",
    "text": "One more step, and you’re ready to go! ",
    "translations": [
      {
        "language": "AR",
        "text": "تبقى خطوة أخرى وتنتهي من إعداد الاستبيان! "
      }
    ]
  },
  {
    "key": "txt_ClickOn_528",
    "text": "Click on <b>“Close Now”</b> to close the survey.  </br>Note: You cannot add or delete respondents once you close the survey. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>“أغلق الآن”</b> لإغلاق الاستبيان. </br>ملحوظة: لن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
      }
    ]
  },
  {
    "key": "txt_CloseSurv_416",
    "text": "Close Survey",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق الاستبيان "
      }
    ]
  },
  {
    "key": "txt_Unlocksea_518",
    "text": "Unlock seamless employee engagement – Reach respondents, even without email, with our general survey link. Click here and start sharing! ",
    "translations": [
      {
        "language": "AR",
        "text": "   جميع المستجيبون يستطيعون المشاركة – يمكنك الوصول إلى المستجيبين حتى بدون بريد إلكتروني باستخدام رابط الاستبيان. انقر هنا وابدأ بالمشاركة! "
      }
    ]
  },
  {
    "key": "txt_Diditgobe_889",
    "text": "Did it go beyond the completion date? Click here to update the deadline and automated reminder dates. ",
    "translations": [
      {
        "language": "AR",
        "text": "هل تجاوزت تاريخ الإكمال؟ انقر هنا لتحديث تاريخ الإكمال وتواريخ التذكير التلقائي. "
      }
    ]
  },
  {
    "key": "txt_UpdateDat_941",
    "text": "Update Dates ",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث التواريخ "
      }
    ]
  },
  {
    "key": "txt_Youcandow_532",
    "text": "You can download the list of respondents with their survey status! </br> Note: Available in Excel format. ",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل قائمة المستجيبين مع حالة الاستبيان الخاص بهم! </br> ملحوظة: متوفر في صيغة Excel. "
      }
    ]
  },
  {
    "key": "txt_ExportRes_128",
    "text": "Export Respondents ",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المستجيبون "
      }
    ]
  },
  {
    "key": "txt_Forgottoa_219",
    "text": "Forgot to add a respondent? No worries, click here and start adding. ",
    "translations": [
      {
        "language": "AR",
        "text": "هل نسيت إضافة مستجيب؟ لا تقلق انقر هنا وابدأ بالإضافة. "
      }
    ]
  },
  {
    "key": "txt_Sendmanua_129",
    "text": "Send manual reminders or delete the respondent. ",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات يدوية أو قم بحذف المستجيب. "
      }
    ]
  },
  {
    "key": "txt_MoreActio_120",
    "text": "More Actions",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات إضافية"
      }
    ]
  },
  {
    "key": "txt_Clickhere_145",
    "text": "Click here to send reminders to respondents who did not complete the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لإرسال تذكيرات للمستجيبين الذين لم يستكملوا الاستبيان. "
      }
    ]
  },
  {
    "key": "txt_Trackyour_168",
    "text": "Track your respondents' progress! </br> Note: We recommend a 65% - 75% response rate for a better analysis. ",
    "translations": [
      {
        "language": "AR",
        "text": "تتبع معدل الاستجابة للمستجيبين. </br>ملحوظة: نوصي بمعدل استجابة يترواح بين 65% - 75% لتحليلات أفضل. "
      }
    ]
  },
  {
    "key": "txt_Onceyouse_314",
    "text": "Once you set up the <b>“Invitation Email”</b>, click here to send the survey invitations and go live!  ",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد أن تقوم بإعداد <b>“دعوة لاستكمال الاستبيان”</b>، انقر هنا لإرسال دعوات الاستبيان وإطلاق الاستبيان مباشرةً!"
      }
    ]
  },
  {
    "key": "txt_Invitatio_215",
    "text": "Invitation Template ",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج الدعوة "
      }
    ]
  },
  {
    "key": "txt_Customize_781",
    "text": "Customize the invitation email template or use the default template generated by Zenithr. </br>Hint: Do not erase the survey link. If erased, click on the <b>default button</b>. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل الدعوة او استخدم النموذج الأساسي المُعرف من  زينثر. </br>ملحوظة: لا تقم بمسح رابط الاستبيان. إذا تم مسحه، انقر على \"النموذج الأساسي\". "
      }
    ]
  },
  {
    "key": "txt_invitation_email_desc",
    "text": "In the <b>“Invitation Email”</b>, you invite the respondents you input in the Respondents section through email. ",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"دعوة لاستكمال الاستبيان\"</b> تقوم بدعوة المستجيبين المضافين في خطوة <b>\"المستجيبون\"</b> من خلال البريد الإلكتروني."
      }
    ]
  },
  {
    "key": "txt_Customize_297",
    "text": "Customize the reminder email template or use the default template generated by Zenithr.</br>Hint: Do not erase the survey link. If erased, click on the <b>default button</b>. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج إيميل التذكير أو استخدم النموذج الأساسي المُعرف من زينثر .</br> ملحوظة: لا تقم بمسح رابط الاستبيان. إذا تم مسحه، انقر على \"<b>النموذج الأساسي</b>\"."
      }
    ]
  },
  {
    "key": "txt_Addupto3a_148",
    "text": "Add up to 3 automated reminders on specific dates to automatically send reminders to respondents who did not complete the survey. ",
    "translations": [
      {
        "language": "AR",
        "text": "أضف 3 تذكيرات تلقائية كحد أقصى في تواريخ محددة لإرسال تذكيرات تلقائية للمستجيبين الذين لم يستكملوا الاستبيان. "
      }
    ]
  },
  {
    "key": "txt_Automated_437",
    "text": "Automated Reminders ",
    "translations": [
      {
        "language": "AR",
        "text": "التذكيرات التلقائية "
      }
    ]
  },
  {
    "key": "txt_Setthecom_342",
    "text": "Set the completion date of your survey!<br><br> Hint: You can extend the completion date after you send the invitations!",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ إكمال الاستبيان! <br><br>تلميح: يمكنك تمديد تاريخ الإكمال بعد إرسال الدعوات!"
      }
    ]
  },
  {
    "key": "txt_SurveyDea_220",
    "text": "Survey Deadline ",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ إكمال الاستبيان "
      }
    ]
  },
  {
    "key": "txt_timeframe_desc",
    "text": "In <b>“Timeframe”</b>, you set the survey deadline in addition to automated reminders. ",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>“المدة الزمنية”</b>، يمكنك تحديد الإطار الزمني للاستبيان بالإضافة إلى تذكيرات تلقائية لاستكمال الاستبيان."
      }
    ]
  },
  {
    "key": "txt_Tostartad_220",
    "text": "To start adding respondents, click on <b>“Add Respondent”</b>.</br> Hint: We recommend adding by using Excel to save time and simplify your experience! ",
    "translations": [
      {
        "language": "AR",
        "text": "للبدء في إضافة المستجيبين، انقر على <b>“إضافة مستجيب”</b>. <br/> تلميح: نوصي باستخدام ملف Excel لتوفير الوقت وتسهيل تجربتك!"
      }
    ]
  },
  {
    "key": "txt_respondents_desc",
    "text": "In the <b>“Respondents”</b> page, you add the Respondents you want to invite to the survey manually, or by Excel file, or from your respondent pool. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"المستجيبون\"</b>، يمكنك إضافة المستجيبين الذين ترغب في دعوتهم للاستبيان يدوياً أو عبر ملف Excel أو من خلال مجموعة المستجيبين الخاصة بك."
      }
    ]
  },
  {
    "key": "txt_Togglethe_828",
    "text": "Enable this option if you want your respondents to fill in the information from the selected criteria above while taking the survey.<br><img class=\"mt-2\" src=\"assets/img/tours/wellbeing-res-info.gif\" />",
    "translations": [
      {
        "language": "AR",
        "text": "ققم بتفعيل هذا الخيار في حال كنت تريد من المستجيبين أن يقوموا بتعبئة المعلومات من المعايير المختارة أعلاه أثناء الاستبيان.<br/><img class=\"mt-2\" src=\"assets/img/tours/wellbeing-res-info.gif\" />"
      }
    ]
  },
  {
    "key": "txt_Responden_431",
    "text": "Respondent Information ",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات المستجيب "
      }
    ]
  },
  {
    "key": "txt_CustomCri_149",
    "text": "Custom Criteria ",
    "translations": [
      {
        "language": "AR",
        "text": "معايير مخصصة"
      }
    ]
  },
  {
    "key": "txt_Youcancre_632",
    "text": "You can create additional criteria. </br>Fill in the criterion name and its options. ",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك إنشاء معايير إضافية. </br>قم بتعبئة اسم المعيار وخياراته."
      }
    ]
  },
  {
    "key": "txt_analytical_criteria_desc",
    "text": "In <b>“Analytical Criteria”</b>, you select the criteria based on your preference as a filter for the analysis.<br><br> Hint: As you expand your selection of criteria, our reports delve deeper, providing you with a comprehensive detailed analysis and comparison!<img class=\"mt-2\" src=\"assets/img/tours/wellbeing-analytical-criteria.gif\" />",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"المعايير التحليلية\"</b>، يمكنك اختيار المعايير استنادًا إلى تفضيلاتك لعرض التحليلات المفصلة. <br><br>تلميح: كلما قمت باختيار معايير أكثر كلما زادت تفاصيل تقاريرنا، مما يوفر لك تحليلًا مفصلًا شاملاً ومقارنًا!<img class=\"mt-2\" src=\"assets/img/tours/wellbeing-analytical-criteria.gif\" />"
      }
    ]
  },
  {
    "key": "txt_Nextstep_435",
    "text": "Next step!",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية!"
      }
    ]
  },
  {
    "key": "txt_step_1",
    "text": "The first step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من الخطوة الأولى. انقر هنا للانتقال إلى الخطوة التالية."
      }
    ]
  },
  {
    "key": "txt_step_2",
    "text": "Another step is done; click here for the next step.",
    "translations": [
      {
        "language": "AR",
        "text": "تم الانتهاء من خطوة أخرى؛ انقر هنا للانتقال إلى الخطوة التالية."
      }
    ]
  },
  {
    "key": "txt_step_3",
    "text": "You are ready to go to the next step! ",
    "translations": [
      {
        "language": "AR",
        "text": "أنت جاهز للانتقال إلى الخطوة التالية!"
      }
    ]
  },
  {
    "key": "txt_Clickonb_749",
    "text": "Click on <b>“Preview Survey”</b> to view your Survey's selected dimensions and statements! </br>  Note: Available in PDF format. To download click “📁”. ",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على <b>“عرض الاستبيان”</b> لعرض الأبعاد والعبارات المختارة في الاستبيان الخاص بك! </br> ملاحظة: متوفر بصيغة PDF. لتنزيل الملف اضغط على “📁”."
      }
    ]
  },
  {
    "key": "txt_Useouradv_513",
    "text": "Use our advanced AI tool to generate statements tailored to your need! ",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم أداة الذكاء الاصطناعي المتطورة لإنشاء عبارات مصممة خصيصًا لاحتياجاتك! "
      }
    ]
  },
  {
    "key": "txt_GenerateS_831",
    "text": "Generate Statement ",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء عبارات "
      }
    ]
  },
  {
    "key": "txt_ClickOnStatement",
    "text": "Click on <b>“New Statement”</b> to add a new custom statement using the agreement scale question type. </br>Hint: Click “👁️” to preview the statement sample used in the survey. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على<b> \"عبارة جديدة\"</b> لإضافة عبارة مخصصة جديدة باستخدام نوع السؤال لمقياس الاتفاق.</br> تلميح: انقر على \"👁️\" لعرض نموذج السؤال الذي سيتم استخدامه في الاستبيان. "
      }
    ]
  },
  {
    "key": "txt_AddStatem_838",
    "text": "Add Statement ",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة عبارة "
      }
    ]
  },
  {
    "key": "txt_EditCusto_165",
    "text": "Edit Custom Dimension ",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل البعد المخصص "
      }
    ]
  },
  {
    "key": "txt_Editordel_801",
    "text": "Edit or delete the new custom dimension. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف البعد المخصص الجديد. "
      }
    ]
  },
  {
    "key": "txtCustomDimensions_desc",
    "text": "If you want to add more statements, first click <b>“New Custom Dimension”</b>.</br> Note: Total Dimensions covering the <b>Predefined</b> and <b>Custom Dimensions</b> shall not exceed 8 Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "إذا كنت ترغب في إضافة المزيد من العبارات، انقر على<b> \"بعد مخصص جديد\"</b>. </br>ملحوظة: يجب ألا يتجاوز إجمالي الأبعاد <b>المُعرفة مسبقاُ</b> و<b>المخصصة </b>عن 8 أبعاد. "
      }
    ]
  },
  {
    "key": "txtDimensions_desc",
    "text": "Maximize your experience with the full <b>Employee Well-being</b> predefined dimensions, or tailor it to your needs by selecting a minimum of 3 dimensions.  ",
    "translations": [
      {
        "language": "AR",
        "text": "حقق أقصى استفادة من تجربة رفاهية الموظف مع أبعاد <b>رفاهية الموظف </b>المُعرفة مسبقاً أو قم بتخصيصها لتناسب احتياجاتك عن طريق اختيار 3 أبعاد كحد أدنى. "
      }
    ]
  },
  {
    "key": "txtDimensions_name",
    "text": "Well-being Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "أبعاد الرفاهية "
      }
    ]
  },
  {
    "key": "txt_translation_desc",
    "text": "Translate text manually with a click on “🌐” or “✨” and let our magical AI Tool do the job for you! ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “🌐”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام  بالمهمة بالنياية عنك!"
      }
    ]
  },
  {
    "key": "txt_Translati_697",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "txt_Fillinyou_655",
    "text": "Fill in your <b>\"Survey Name\"</b>. </br></br> You can add a description as well. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة <b>اسم الاستبيان</b>.</br></br> يمكنك أيضاً إضافة وصف للاستبيان."
      }
    ]
  },
  {
    "key": "txt_SurveyDet_371",
    "text": "Survey Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل الاستبيان "
      }
    ]
  },
  {
    "key": "txt_survey_info_desc",
    "text": "In <b>“Survey Information</b>”, you specify the main elements, including survey name and dimensions & statements! ",
    "translations": [
      {
        "language": "AR",
        "text": "في <b>\"معلومات الاستبيان\"</b> تُحدد العناصر الرئيسية، بما في ذلك اسم الاستبيان والأبعاد والعبارات."
      }
    ]
  },
  {
    "key": "txt_Clickhere_208",
    "text": "Click here to delete a draft survey.<br><br> Note: only draft surveys can be deleted",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لحذف الاستبيانات المسودة. <br><br>ملحوظة: يمكن حذف استبيانات المسودة فقط"
      }
    ]
  },
  {
    "key": "txt_DeleteSur_232",
    "text": "Delete Survey",
    "translations": [
      {
        "language": "AR",
        "text": "حذف استبيان "
      }
    ]
  },
  {
    "key": "txt_Tocreatea_600",
    "text": "To create a new survey, click on <b>“New Setup”</b>.",
    "translations": [
      {
        "language": "AR",
        "text": "انقرعلى <b>\"إعداد جديد\"</b> لإنشاء استبيان جديد."
      }
    ]
  },
  {
    "key": "txt_OpenSurve_592",
    "text": "Open Survey ",
    "translations": [
      {
        "language": "AR",
        "text": "فتح استبيان "
      }
    ]
  },
  {
    "key": "txt_Pointthem_434",
    "text": "Point the mouse over the survey list to open draft, live, and closed surveys. ",
    "translations": [
      {
        "language": "AR",
        "text": "ضع مؤشر الماوس فوق قائمة الاستبيانات لفتح الاستبيانات بحالة المسودة، المباشرة، والمنتهية."
      }
    ]
  },
  {
    "key": "txtPreparingHeatmap",
    "text": "Preparing Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير المخطط"
      }
    ]
  },
  {
    "key": "txtDownloadHeatmap",
    "text": "Download Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المخطط"
      }
    ]
  },
  {
    "key": "txtDisagree",
    "text": "Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtAgree",
    "text": "Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtStronglyDisagree",
    "text": "Strongly Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "غير موافق بشدة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtStronglyAgree",
    "text": "Strongly Agree",
    "translations": [
      {
        "language": "AR",
        "text": "موافق بشدة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtPeople",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون"
      },
      {
        "language": "FR",
        "text": "Répondants"
      }
    ]
  },
  {
    "key": "txtApply",
    "text": "Apply",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق"
      }
    ]
  },
  {
    "key": "txtSelectEntity",
    "text": "Selected Entity",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة"
      }
    ]
  },
  {
    "key": "txt_dates_error",
    "text": "date error",
    "translations": [
      {
        "language": "AR",
        "text": "خطأ في التاريخ"
      }
    ]
  },
  {
    "key": "txtNoSentiment",
    "text": "No Sentiment",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد"
      }
    ]
  },
  {
    "key": "WB:EXCEL:3001",
    "text": "Invalid emails",
    "translations": [
      {
        "language": "AR",
        "text": "بريد الكتروني غير صالح"
      }
    ]
  },
  {
    "key": "WB:EXCEL:3000",
    "text": "Duplication Emails in Excel Sheet",
    "translations": [
      {
        "language": "AR",
        "text": "تكرار البريد الإلكتروني في ورقة إكسل"
      }
    ]
  },
  {
    "key": "txtWokplaceWellbeingEx",
    "text": "Workplace Well-being Experience By",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة الرفاهية في مكان العمل حسب"
      }
    ]
  },
  {
    "key": "txt_search",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      }
    ]
  },
  {
    "key": "txt_progress",
    "text": "Progress",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      }
    ]
  },
  {
    "key": "txt_user_email",
    "text": "Email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني"
      }
    ]
  },
  {
    "key": "txt_full_name",
    "text": "Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      }
    ]
  },
  {
    "key": "txt_employee_ID",
    "text": "Employee ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      }
    ]
  },
  {
    "key": "txtIndex",
    "text": "Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر"
      }
    ]
  },
  {
    "key": "txtNeutral",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "حيادي"
      }
    ]
  },
  {
    "key": "txtWellbeing",
    "text": "Employee Wellbeing",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtCommentAiChartTitle",
    "text": "Comments’ Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات التعليقات"
      }
    ]
  },
  {
    "key": "txtNeutralAISection",
    "text": "Neutral",
    "translations": [
      {
        "language": "AR",
        "text": "حيادي"
      }
    ]
  },
  {
    "key": "txtNegative",
    "text": "Negative",
    "translations": [
      {
        "language": "AR",
        "text": "سلبي"
      }
    ]
  },
  {
    "key": "txtPositive",
    "text": "Positive",
    "translations": [
      {
        "language": "AR",
        "text": "إيجابي"
      }
    ]
  },
  {
    "key": "txtAtleastRespondentsRequired",
    "text": "At least 3 respondents should complete the survey in order to close it",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استكمال الاستبيان من قبل 3 من المستجيبين على الأقل من أجل إغلاقه"
      }
    ]
  },
  {
    "key": "txtDistribution",
    "text": "Distribution",
    "translations": [
      {
        "language": "AR",
        "text": "توزيع الإجابات"
      }
    ]
  },
  {
    "key": "txtStatement",
    "text": "Statement",
    "translations": [
      {
        "language": "AR",
        "text": "العبارة"
      }
    ]
  },
  {
    "key": "Applied Filters",
    "text": "Applied Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر المُطبَّقة"
      }
    ]
  },
  {
    "key": "Performance",
    "text": "Performance",
    "translations": [
      {
        "language": "AR",
        "text": "الأداء"
      }
    ]
  },
  {
    "key": "Tenure",
    "text": "Tenure",
    "translations": [
      {
        "language": "AR",
        "text": "الفئة"
      }
    ]
  },
  {
    "key": "HR Metrics",
    "text": "HR Metrics",
    "translations": [
      {
        "language": "AR",
        "text": "مقاييس الموارد البشرية"
      }
    ]
  },
  {
    "key": "Demographics",
    "text": "Demographics",
    "translations": [
      {
        "language": "AR",
        "text": "التركيبة السكانية"
      }
    ]
  },
  {
    "key": "Extra Criteria",
    "text": "Extra Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "معايير اضافية"
      }
    ]
  },
  {
    "key": "Business Level",
    "text": "Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "مستوى العمل"
      }
    ]
  },
  {
    "key": "JobGrade",
    "text": "Job Grades",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجات الوظيفية"
      }
    ]
  },
  {
    "key": "BandLevel",
    "text": "Band Levels",
    "translations": [
      {
        "language": "AR",
        "text": "المستويات الوظيفية"
      }
    ]
  },
  {
    "key": "PerformanceRate",
    "text": "Performance Rates",
    "translations": [
      {
        "language": "AR",
        "text": "تقييمات الأداء"
      }
    ]
  },
  {
    "key": "TenureGroup",
    "text": "Tenure Groups",
    "translations": [
      {
        "language": "AR",
        "text": "فئات سنوات الخدمة"
      }
    ]
  },
  {
    "key": "AgeGroup",
    "text": "Age Groups",
    "translations": [
      {
        "language": "AR",
        "text": "الفئات العمرية"
      }
    ]
  },
  {
    "key": "Generation",
    "text": "Generation",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الجيل"
      }
    ]
  },
  {
    "key": "Gender",
    "text": "Gender",
    "translations": [
      {
        "language": "AR",
        "text": "الجنس"
      }
    ]
  },
  {
    "key": "Nationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية"
      }
    ]
  },
  {
    "key": "txtAtLeastRespondentsToStart",
    "text": "At least one respondent is needed to proceed",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة مستجيب واحد على الأقل"
      }
    ]
  },
  {
    "key": "txtDriver/Question",
    "text": "Dimension / statement",
    "translations": [
      {
        "language": "AR",
        "text": "البعد/العبارة"
      }
    ]
  },
  {
    "key": "txtDriversofWorkplaceWellbeing",
    "text": "Workplace Wellbeing Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "أبعاد رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtStatements",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      }
    ]
  },
  {
    "key": "txtEmployeeIndexByDimension",
    "text": "Employee Well-Being Index by Dimension",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر رفاهية الموظف حسب البعد"
      }
    ]
  },
  {
    "key": "txtFinancialWellbeingVPOOREXPRecomendations3",
    "text": "Create a financial wellness program and policy. Establish a Financial Well-being Fund by allocating a specific percentage of the organization’s revenue. Implement various initiatives, including earned salary access, debt counseling, upskilling support, and hardship loans, to improve employees' financial well-being. Regularly track the number of employees benefiting from each initiative and review their effectiveness. Additionally, offer benefits such as life and health insurance, housing, and caregiving allowances to further support employees' financial stability. The organization may prioritize interventions for junior or lower wage bracket employees. These efforts will contribute to creating a resilient and financially secure workforce.",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء برنامج وسياسة الرفاهية المالية. يمكن للمؤسسة تخصيص نسبة محددة من إيراداتها لإنشاء صندوق يساهم في الرفاهية المالية للموظفين بشكل دوري. كما يمكن للمؤسسة تنفيذ مبادرات متنوعة في هذا المجال، بما في ذلك قدرة الموظف على الوصول إلى الراتب المكتسب، والإرشاد المالي، ودعم التطوير المهني، والقروض العُسرية، لتحسين رفاهية الموظفين المالية. يجب على المؤسسة مراقبة عدد الموظفين الذين يستفيدون من كل مبادرة ومدى فعالية هذه المبادرات بانتظام. بالإضافة إلى ذلك يمكن للمؤسسة تقديم فوائد مثل التأمين على الحياة، والتأمين الصحي، وبدلات السكن والرعاية، وذلك لدعم استقرار الموظفين المالي بشكل أكبر (قد تعطي المؤسسة الأولوية للموظفين الجُدد أو ذوي الأجور المنخفضة). ستساهم هذه الجهود في خلق بيئة عمل متينة و آمنة مالياً."
      }
    ]
  },
  {
    "key": "txtFinancialWellbeingVPOOREXPRecomendations2",
    "text": "Improve pay equity and pay equality. Ensure equal pay and benefits for all employees engaged in similar work in alignment with industry standards and organization resources, irrespective of their background. Establish a transparent reward and pay distribution process based on comprehensive job role evaluations. This initiative will enhance trust and foster a sense of fairness among employees.",
    "translations": [
      {
        "language": "AR",
        "text": "تحسين مفهوم المساواة في الأجور لكافة الجوانب. يجب أن يحصل جميع الموظفين على رواتب ومزايا متساوية للأعمال المتماثلة وبما يتوافق مع معايير العمل وموارد المؤسسة ، و بغض النظر عن خلفيتهم القادمين منها. اتباع عملية عادلة في دفع الأجور وإعطاء المكافآت مبنية على تقييمات مسؤوليات الوظائف يساهم في تعزيز الثقة والشعور بالإنصاف بين الموظفين."
      }
    ]
  },
  {
    "key": "txtFinancialWellbeingVPOOREXPRecomendations1",
    "text": "Ensure fair pay and employee benefits. Implement a feasible base salary increase, secure working hours, and reduce compensation-related worries by ensuring regular and timely salary payments. This initiative must address living situation changes and align with the organization's financial resources.",
    "translations": [
      {
        "language": "AR",
        "text": "ضمان رواتب ومزايا عادلة لجميع الموظفين. ترتبط الرفاهية المالية ارتباطاً وثيقاً بدخل الموظف. وبالتالي، يجب التأكد من حصول الموظفين على راتب أساسي معقول قابل للزيادة، وساعات عمل آمنة. وكذلك، وضمان دفع رواتب منتظمة وفي الوقت المحدد، لتقليل القلق المرتبط بالتعويضات. لتطبيق ما ذكر أعلاه يجب الأخذ بعين الاعتبار التغيرات المستمرة في ظروف المعيشة و التوافق مع موارد المؤسسة المالية."
      }
    ]
  },
  {
    "key": "txtOccupationalWellbeingVPOOREXPRecomendations3",
    "text": "Support employees to upskill and find meaning. Provide employees access to on-demand learning platforms (Udemy, Coursera, LinkedIn Learning etc.) and subsidize upskilling costs to enhance their skill sets. Additionally, allocate 3-4 hours weekly to learn skills for their future roles. Schedule regular feedback, coaching, and career counseling sessions to support employees in adapting to changes in their job roles and identify employees' strengths, weaknesses, interests, values, and potential. These initiatives can also help employees reframe their outlook toward the job to make it more meaningful.",
    "translations": [
      {
        "language": "AR",
        "text": "دعم الموظفين لتعزيز مهاراتهم وجعلها ذات مغزى. يمكن للمؤسسة أن توفر للموظفين إمكانية تعزيز مهاراتهم من خلال الاستثمار في منصات التعلم (Udemy, Coursera, LinkedIn Learning). ويمكن للمؤسسة إعطاء الأولوية لتعزيز مهارات الموظفين من خلال تخصيص بضع ساعات (3-4 ساعات) أسبوعياً لتعلم المهارات التي ستساعدهم في دورهم المستقبلي. بالإضافة إلى ذلك، قد تحدد المؤسسات بعض الوقت لتلقي ردود الموظفين، وتقديم خدمات التدريب، وخدمات الإرشاد المهني لمساعدة الموظفين على التكيف مع التغييرات في أدوارهم الوظيفية. كما يمكنهم أيضاً تحديد نقاط القوة والضعف والإمكانات لدى الموظفين. يمكن أن تساعد هذه المبادرات الموظفين على إعادة صياغة نظرتهم للوظيفة لجعلها أكثر جدوى."
      }
    ]
  },
  {
    "key": "txtOccupationalWellbeingVPOOREXPRecomendations2",
    "text": "Consider redesigning the job role. Annually, conduct reflective sessions with the team to identify aspects of their roles that energize and drain them. Utilize this information to enhance job roles and leverage team strengths proactively. Implement automation, digitalization, and innovative solutions to optimize productivity and efficiency. Engage employees in high-value tasks to benefit the organization and its customers. Regularly evaluate progress to ensure continuous improvement.",
    "translations": [
      {
        "language": "AR",
        "text": "النظر في إعادة تصميم الدور الوظيفي. مع تطور الأدوار والمسؤوليات الوظيفية، فإنه يصبح من الضروري التفكير سنوياً مع الفريق في جوانب دورهم الوظيفي التي تعمل على تنشيطهم وتحفيزهم. ستساعد هذه المعلومات المؤسسة على تحسين الأدوار الوظيفية والاستفادة دورياً من نقاط قوة الفريق، كما يمكن للمؤسسة  تطبيق عمليات الأتمتة والرقمنة والحلول الابتكارية لتحسين الإنتاجية والكفاءة، بالإضافة إلى إشراك الموظفين في مهام ذات قيمة عالية لصالح المؤسسة وعملائها. يجب على المؤسسة القيام بتقييم التقدم بانتظام لضمان التحسين المستمر."
      }
    ]
  },
  {
    "key": "txtOccupationalWellbeingVPOOREXPRecomendations1",
    "text": "Connect employees to the big picture. Offer opportunities for employees to learn about the organization's vision and how their role contributes to achieving it. Show employees how the leadership is committed to the organization's vision and impact through their actions and behavior.  Additionally, show appreciation for employees who contribute to the organization's vision through public recognition, bonuses, promotions, or other incentives.",
    "translations": [
      {
        "language": "AR",
        "text": "ربط الموظفين بالرؤية الشاملة للمؤسسة. منح فرص للموظفين للتعرف على رؤية المؤسسة وعلى كيفية مساهمة دورهم في تحقيقها. على المؤسسة أن تظهر لموظفيها كيف تلتزم القيادة برؤية المؤسسة وتأثير أفعالهم وسلوكهم على ذلك. كما يمكن للمؤسسة أيضاً إظهار التقدير للموظفين الذين يساهمون في تحقيق رؤية المؤسسة من خلال إظهار التقدير أو إعطاء المكافآت أو الترقيات أو غيرها من الحوافز."
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPRecomendations4",
    "text": "Increase Transparency and Personal Accountability. Ensure managers foster a sense of accountability by setting individual and team goals and regularly reviewing progress towards these goals. Build trust and improve collaboration by demonstrating integrity, involving the team in crucial decisions, and recognizing individual contributors in collaborative projects.",
    "translations": [
      {
        "language": "AR",
        "text": "رفع مستوى الشفافية والمساءلة الشخصية. يمكن للمدراء تعزيز شعور المساءلة من خلال تحديد الأهداف الفردية والجماعية، ومراجعة التقدم المحرز في تحقيق هذه الأهداف بشكل دوري. كما يمكن للمدراء بناء الثقة وتعزيز التعاون من خلال إظهار النزاهة، وإشراك الفريق في اتخاذ القرارات الحاسمة، وتقدير المساهمين الفرديين في المشاريع التعاونية."
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPRecomendations3",
    "text": "Foster a sense of community. Create a sense of belonging and community within the workplace. Some initiatives the organization can consider include starting an employee-run book club, organizing an organizational sports league, or setting up an employee-run mentoring program. Encourage employees to donate their time, energy, and resources to support causes and communities as part of their corporate social responsibility initiatives. ",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز الشعور بالانتماء للمؤسسة. خلق شعور بالانتماء والوحدة داخل مكان العمل. وتتضمن بعض المبادرات التي يمكن للمؤسسة التفكير فيها  إنشاء نادي للقراءة يديره الموظفون أو تنظيم دوري رياضي للمؤسسة أو إعداد برنامج توجيه يديره الموظفون. وقد تشجع المؤسسة أيضاً الموظفين على التبرع بوقتهم وطاقتهم ومواردهم لجعلهم يرغبون في تقديم الدعم بشكل جماعي باعتبارهم مجتمعاً واحداً  كجزء من مساهمتهم في مبادرات المسؤولية الاجتماعية."
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPRecomendations2",
    "text": "Encourage collaboration. Create opportunities for employees to collaborate on projects and initiatives and provide the necessary resources and support to collaborate successfully. Some valuable resources include training on teamwork, providing tools and technology that facilitate collaboration, and recognizing and rewarding successful partnerships. ",
    "translations": [
      {
        "language": "AR",
        "text": "تشجيع التعاون. خلق فرص للموظفين للتعاون في المشاريع والمبادرات وتوفير الموارد اللازمة والدعم للتعاون بنجاح. وتتضمن بعض الموارد القيمة التدريب على العمل الجماعي، وتوفير الأدوات والتكنولوجيا التي تسهل التعاون، وتقدير الشراكات الناجحة ومكافأتها."
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPRecomendations1",
    "text": "Promote open communication. Encourage employees to communicate openly, honestly, and respectfully with each other and their managers. Ensure regular team meetings, one-on-one check-ins, and create channels for informal communication (tea breaks, group lunches, games, etc. may help). Empower managers to show genuine interest and empathy towards their employees to create a supportive work environment and improve team morale.",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز التواصل المفتوح. تشجيع الموظفين على التواصل بصراحة وصدق واحترام مع بعضهم البعض ومع مدرائهم. ويمكن للمؤسسة تحقيق ذلك من خلال عقد اجتماعات دورية للفريق، والتواصل الفردي، ومن خلال إنشاء قنوات للتواصل غير الرسمي (قد يساعد في ذلك أخذ استراحة الشاي أو القهوة، وتناول وجبات غداء جماعية، والألعاب، وما إلى ذلك). يجب على المؤسسة منح المدراء القدرة على التعبير عن اهتمامهم الصادق تجاه موظفيهم لخلق بيئة عمل داعمة وتحسين روح الفريق الواحد."
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPRecomendations4",
    "text": "Provide training for managers and supervisors. Train managers and supervisors to enhance their understanding of psychological factors, enable them to effectively manage and communicate with employees, and foster a positive and supportive work environment.",
    "translations": [
      {
        "language": "AR",
        "text": "توفير التدريب للمدراء والمسؤولين. يجب على أصحاب العمل تدريب المدراء والمسؤولين لتعزيز فهمهم للعوامل النفسية، وتمكينهم من إدارة الموظفين والتواصل معهم بشكل فعال لتعزيز بيئة عمل إيجابية وداعمة."
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPRecomendations3",
    "text": "Address workplace stressors. Conduct regular surveys or employee focus groups to identify specific workplace stress sources. Some everyday stressors include unrealistic deadlines, lack of resources, poor communication, and lack of autonomy. Address negative interactions and toxic behavior, such as bullying or harassment, to improve the psychological well-being of employees.",
    "translations": [
      {
        "language": "AR",
        "text": "معالجة ضغوط مكان العمل. يجب على أرباب العمل إجراء استبيانات دورية أو عمل جلسات نقاش مع الموظفين لتحديد المصادر التي تتسبب في حدوث توتر في مكان العمل. وتشمل بعض الضغوطات اليومية المواعيد النهائية غير الواقعية لتسليم الأعمال المنوطة بهم، ونقص الموارد وضعف التواصل والافتقار إلى الاستقلالية. إلى جانب ذلك، يجب على أصحاب العمل معالجة التفاعلات السلبية بين الموظفين والسلوك السيء، مثل التنمر أو التحرش، إلخ."
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPRecomendations2",
    "text": "Ensure employees can disconnect from work. Ensure employees disconnect from work after work hours and take regular breaks during non-work hours to reduce stress and enhance work-life balance. Additionally, create guidelines for flexible or remote work arrangements to effectively support employees in managing their work and personal responsibilities. ",
    "translations": [
      {
        "language": "AR",
        "text": "توفير الفرص للموظفين للانفصال عن العمل. السماح للموظفين بأخذ فترات راحة منتظمة وقطع التواصل مع العمل بعد ساعات العمل الرسمية لتقليل التوتر وتعزيز التوازن بين العمل والحياة. كما يمكن لأصحاب العمل أيضاً دعم الموظفين من خلال السماح لهم بالعمل بمرونة أو عن بُعد لتحقيق التوازن بين عملهم ومسؤولياتهم الشخصية بشكل أفضل."
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPRecomendations1",
    "text": "Promote a culture of openness and support. Encourage employees to talk openly about their mental health and offer resources such as employee assistance programs, counseling services, and mental health days to support employees in handling stress and maintaining good psychological well-being. Provide resources and training on - time management training, relaxation techniques, mindfulness practices, etc.  to help employees handle stress. ",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز ثقافة الانفتاح والدعم. تشجيع الموظفين على التحدث بصراحة عن صحتهم النفسية، وتقديم الموارد اللازمة لهم مثل برامج مساعدة الموظفين، وخدمات تقديم المشورة، وأيام الصحة النفسية لدعم الموظفين في كيفية معالجة الإجهاد والحفاظ على صحة نفسية جيدة. كما يمكنهم أيضاً توفير الموارد والتدريب لمساعدة الموظفين على كيفية معالجة الإجهاد، مثل التدريب على إدارة الوقت وتقنيات الاسترخاء وممارسات التركيز الذهني."
      }
    ]
  },
  {
    "key": "txtRecommendations",
    "text": "Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "التوصييات"
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPRecomendations4",
    "text": "Communicate effectively. Establish an efficient communication system to effectively relay health and safety information to employees. Provide comprehensive guidance on potential hazards, incident reporting, and updates on policies and procedures. Ensure clarity regarding employee rights, responsibilities, and points of contact for inquiries or concerns. Regularly evaluate the effectiveness of the communication strategy to enhance health and safety awareness and compliance.",
    "translations": [
      {
        "language": "AR",
        "text": "التواصل الفعال. التواصل بشكل فعال مع الموظفين حول مواضيع الصحة والسلامة، بما في ذلك تزويدهم بالمعلومات حول المخاطر المحتملة، والإبلاغ عن الحوادث، ومشاركة التحديثات حول السياسات أو الإجراءات الجديدة. وعلاوة على ذلك، ضمان فهم الموظفين لحقوقهم ومسؤولياتهم ومن هي جهات الاتصال التي يجب اللجوء اليها للاستفسارات. يجب على المؤسسة أن تقوم بتقييم فعالية استراتيجية الاتصال بشكل منتظم لتعزيز الوعي بالصحة والسلامة والامتثال."
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPRecomendations3",
    "text": "Promote a healthy lifestyle. Implement a comprehensive employee wellness program to promote regular exercise, healthy eating, and stress management. Provide dedicated spaces for healthy food options and adequate space to encourage employees to take breaks for physical activity and stretching. ",
    "translations": [
      {
        "language": "AR",
        "text": "تعزيز أسلوب حياة صحية. تنفيذ برنامجًا شاملاً يضمن رفاهية الموظفين ويعزز ممارسة التمارين الرياضية بانتظام، وتحسين عادات التغذية الصحية،  وكيفية إدارة التوتر، بالإضافة إلى توفير خيارات طعام صحية للموظفين ومساحة كافية لتشجيعهم على أخذ فترات راحة لممارسة الأنشطة البدنية."
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPRecomendations2",
    "text": "Create an ergonomic work environment: Provide ergonomic furniture and equipment to reduce the risk of injury and strain caused by poor posture, repetitive motions, and other work-related hazards. Provide regular training and education on health and safety topics to all employees. Some activities may include things like first aid, fire safety, and training on specific hazards that are present in the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "خلق بيئة عمل مريحة. توفير أثاث ومعدات مريحة للتقليل من مخاطر الإصابات والإجهاد الناجم عن الأوضاع السيئة والتحرك المستمر والمخاطر الأخرى المتعلقة بالعمل. وكذلك، يجب توفير تدريب وتعليم دوري حول مواضيع الصحة والسلامة لجميع الموظفين. وقد تتضمن بعض الأنشطة أشياءً مثل الإسعافات الأولية والوقاية من الحرائق والتدريب على مخاطر معينة موجودة في مكان العمل."
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPRecomendations1",
    "text": "Introduce wellness leaves. Assess feasibility and introduce wellness leaves for eligible organizations by aligning with labor law and compliance requirements. By the start of the following calendar year, the organization may introduce a wellness leave policy that allows employees to use their accrued sick leave to promote well-being and illness prevention (like massages, sleep adjustments, wellness classes, and preventive health screenings). Update policies, inform employees, and monitor the usage of wellness leaves to promote well-being and illness prevention. Collaborate with healthcare experts to support employee health and reinforce the organization’s commitment to their well-being. ",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز مفهوم الإجازات المرضية إلى إجازات إضافية (وقائية). يمكن للمؤسسات المؤهلة أن تقوم بطرح مفهوم الإجازات الإضافية (الوقائية) وبما بتوافق مع قوانين العمل ومتطلبات الامتثال. يمكن للمؤسسات في بداية العام طرح سياسة تمكن الموظفين من استخدام إجازاتهم المرضية المدفوعة غير المستخدمة لأغراض صحية وقائية مثل الذهاب لجلسات التدليك، وجلسات تعديل دورات النوم، وأخذ دروس عن الصحة الوقائية، هذا وبالإضافة إلى تشجيع الموظفين على القيام وبشكل دوري بعمل فحوصات وتحاليل طبية ووقائية). على المؤسسة أن تقوم بتحديث السياسات فيما يخص هذا المجال، وإبلاغ الموظفين، ورصد ومتابعة استخدام الإجازات الإضافية الوقائية لدعم الرعاية الصحية والوقاية من الأمراض. كما يمكن للمؤسسة التعاون مع خبراء في مجال الرعاية الصحية لدعم صحة الموظفين وتعزيز التزام المؤسسة بالحفاظ على صحتهم ورفاهيتهم."
      }
    ]
  },
  {
    "key": "txtFinancialWellbeingVPOOREXPDescription",
    "text": "<p>Financial well-being refers to a state of financial wellness where employees have enough money to meet their basic needs and can cope with financial shocks like job loss. Employees may face stress because of current money management issues and because they are worried about their future financial security. The most common factors contributing to financial stress are the individual's wealth, knowledge, attitude toward finances, and current economic behavior. Lack of fair compensation and benefits, inflation, unexpected medical expenditure, student loans, stress related to potential layoffs, retirement, and caregiving responsibilities may lead to financial distress in employees.<br><br>Financial Well-being assesses if the current workplace provides financial safety and security to its employees. Financial stress can lead to absenteeism (an employee stays away from work without a valid reason) and presenteeism (an employee shows up at work but is not fully engaged) among employees. Financial stress may also decrease organizational commitment; hence they are less likely to be proactive, engaged, and satisfied with their current job. If a company scores low on this dimension, its employees face financial distress or dissatisfaction. </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير الرفاهية المالية إلى حالة من الاستقرار المالي حيث يكون لدى الفرد ما يكفيه من المال لتلبية احتياجاته الأساسية، ويمكّنه من التعامل مع الصدمات المالية مثل فقدان الوظيفة.  وقد تشكل كيفية إدارة الأموال الحالية والأمن المالي المستقبلي ضغوطاً  كبيرة على الموظفين، وفي هذا السياق، جدير بالذكر أن العوامل الأكثر شيوعاً التي تساهم في الضغوط المالية هي ثروة الفرد الحالية، والمعرفة التي يمتلكها في هذا المجال، وموقفه تجاه الشؤون المالية والسلوك الاقتصادي الحالي. وقد يؤدي عدم وجود تعويضات ومزايا عادلة، والتضخم الاقتصادي، والنفقات الطبية غير المتوقعة، والقروض الطلابية، والضغوط المرتبطة بتسريح العمال، والتقاعد، والمسؤوليات المتعلقة بتقديم الرعاية  إلى ضائقة مالية لدى الموظفين.<br><br>وتُقيّم الرفاهية المالية ما إذا كانت المؤسسة توفر الأمن والسلامة المالية لموظفيها. وفي هذا السياق، تجدر الإشارة إلى أن الضغط المالي يؤدي إلى التغيب المستمر عن العمل (يبقى الموظف بعيداً عن العمل دون سبب وجيه) والحضور الشكلي (يتواجد الموظف في العمل ولكنه لا يشارك بشكل كامل)، وقد يؤدي الضغط المالي أيضاً إلى انخفاض مستوى التزامات الموظفين بالعمل في المؤسسة، ووبذلك فإنه من  المرجح أن يكونوا غير استباقيين ومشاركين وراضين عن وظائفهم الحالية. واستناداً إلى ما ذكر أعلاه، إذا سجلت المؤسسة درجات منخفضة في هذا البعد، فإن موظفيها يواجهون ضائقة مالية أو حالة عدم رضا.</p>"
      }
    ]
  },
  {
    "key": "txtOccupationalWellbeingVPOOREXPDescription",
    "text": "<p>\"Occupational well-being\" refers to an employee's sense of purpose, growth, and fulfillment. Occupational well-being measures the presence of meaning, growth, and positive emotions toward the organization and current profession or job role. This dimension is closely related to employee engagement and satisfies an employee's need to improve and be part of something beyond oneself.<br><br>When people are involved in decisions about their work environment, tasks, and goals, they are likelier to feel that their opinions and ideas are valued. Involving employees can lead to a more positive work culture and satisfying work experience. Similarly, people are more motivated and engaged when they think their work is essential and makes a difference. When employees feel their work matters, it can increase job satisfaction, improving overall well-being.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير الرفاهية المهنية إلى إحساس الموظف بالهدف والنمو والالتزام. يقيس مفهوم الرفاهية المهنية فهم الغرض من الوظيفة الحالية والإحساس بالمشاعر الإيجابية تجاهها وتجاه المؤسسة. هذه البعد مرتبط ارتباطًا وثيقًا بالارتباط الوظيفي للموظفين ويفي بحاجتهم للتحسين المستمر وأن يكونوا جزءًا من شيء يتجاوز ذاتهم. تشير الرفاهية المهنية إلى إحساس الموظف بالهدف والنمو والالتزام. يقيس مفهوم الرفاهية المهنية وجود المغزى والنمو والمشاعر الإيجابية تجاه الوظيفة الحالية للشركة أو دورها الوظيفي. ويرتبط هذا البعد ارتباطاً وثيقاً بمشاركة الموظفين، ويلبي حاجة الموظف إلى التحسين وأن يكون جزءاً من شيء يتجاوز مصلحته الشخصية.<br><br>عندما يشارك الموظفين في القرارات المتعلقة ببيئة عملهم ومهامهم وأهدافهم، فمن المرجح أن يشعروا بأن آرائهم وأفكارهم تحظى بالتقدير، ويمكن أن يؤدي إشراك الموظفين بتلك القرارات إلى بروز ثقافة عمل أكثر إيجابية وتجربة عمل مرضية. وبالمثل، يكون الموظفون أكثر حماساً واندماجاً بالعمل عندما يعتقدون أن عملهم ضروري وأنه يحدث فرقاً، وعندما يشعر الموظفون أن عملهم مهم، يمكن أن يؤدي ذلك إلى زيادة الرضا الوظيفي وتعزيز الرفاهية العامة.</p>"
      }
    ]
  },
  {
    "key": "txtSocialWellbeingVPOOREXPDescription",
    "text": "<p>Social Well-being is where employees have strong and dependable working relations with coworkers, managers, and clients. It is a crucial component of overall Employee well-being and is closely related to physical and mental health. People with a reliable support network feel secure and less anxious or stressed at work. Being part of a community can also boost social well-being. <br><br>Social well-being assesses whether an organization fosters a culture of trust, personal connection, and social support among its employees. This can boost job satisfaction among employees and improve employee retention.<br><br>Organizations with high scores in this dimension will likely have productivity in teams and roles requiring collaboration and teamwork. These organizations might also have workplace design, practices, and culture that encourage employees to build connections and maintain healthy & meaningful relationships at work.<br><br>The social well-being of employees may be poor if employees work remotely or in a hybrid setting, are new, or are marginalized due to their differences. Organizations with low scores may need to investigate and take proactive steps to prevent employees from feeling excluded, lonely, or isolated. </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تتمثل الرفاهية الاجتماعية في أن يكون للموظفين علاقات عمل قوية وموثوقة مع زملائهم في العمل ومدرائهم وعملائهم. وتعتبر الرفاهية الاجتماعية عنصر حاسم في رفاهية الموظف بشكل عام، وترتبط ارتباطاً وثيقاً بالصحة الجسدية والنفسية، ويشعر الأشخاص الذين يتمتعون بدعم اجتماعي قوي بالأمان ويكونون أقل قلقاً أو توتراً في مكان العمل. وجدير بالذكر أن كون الشخص جزءاً من مجتمع ما بشكل عام يعزز الرفاهية الاجتماعية وبشكل كبير.<br><br>وتقيم الرفاهية الاجتماعية عما إذا كانت المؤسسة تعزز ثقافة الثقة والاتصال الشخصي والدعم الاجتماعي بين موظفيها. كما يمكن أن تعزز الرفاهية الاجتماعية للموظفين رضاهم الوظيفي وتحسن معدل استبقاء الموظفين.<br><br>ومن المحتمل أن تتمتع المؤسسات ذات الدرجات العالية في هذا البعد بالإنتاجية في فرق العمل والمسؤوليات والمهام التي تتطلب التعاون والعمل الجماعي. وقد يكون لهذه المؤسسات أيضاً بيئة عمل وممارسات وثقافة معينة تشجع الموظفين على بناء علاقات صحية وذات مغزى في العمل والحفاظ عليها.<br><br>وقد تكون الرفاهية الاجتماعية للموظفين سيئة إذا كان الموظفون يعملون عن بعد أو في بيئة هجينة، أو إذا كانوا جديدين في العمل، أو تم تهميشهم بسبب الاختلافات فيما بينهم. وقد تحتاج المؤسسات ذات الدرجات المنخفضة إلى التحقيق في مدى تطبيقها للرفاهية الاجتماعية للموظفين، واتخاذ خطوات استباقية لمنع الموظفين من الشعور بالتهميش أو الوحدة أو العزلة في العمل.</p>"
      }
    ]
  },
  {
    "key": "txtPsychologicalWellbeingVPOOREXPDescription",
    "text": "<p>Psychological well-being refers to mental well-being and the ability to disconnect from work to manage personal life. Work-related stressors can affect mental health by making it difficult for employees to balance work and personal responsibilities. Not doing well can further lead to feelings of guilt and inadequacy, which can negatively impact mental health. Psychological Well-being assesses whether employees feel their organization cares about their mental health and work-life balance. <br><br>The organization need to identify and address workplace stress sources to promote a healthier and more balanced workforce. <br><br>Work-related Stressors can affect an individual's emotions and lead to various mental health problems, such as anxiety, depression, and even burnout. <br><br>Organizations can improve employee satisfaction, enhance productivity, and reduce absenteeism by prioritizing mental health and work-life balance. Organizations that do not prioritize psychological well-being can risk leaving employees emotionally exhausted and indifferent toward their work. </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير الرفاهية النفسية إلى الصحة العقلية والقدرة على الفصل بين العمل والحياة الشخصية. يمكن أن تؤثر الضغوطات المرتبطة بالعمل على الصحة النفسية من خلال جعل الموظفين في حالة يصعب عليهم فيها الموازنة بين مسؤوليات العمل والمسؤوليات الشخصية مما قد يؤدي إلى الشعور بالذنب وعدم الكفاءة، وبالتالي يؤثر سلباً على صحتهم النفسية. وتُقيّم الرفاهية النفسية مدى شعور الموظفين بأن صاحب العمل يهتم بصحتهم النفسية وبقدرتهم على الموازنة بين العمل والحياة الشخصية. ويحتاج أرباب العمل إلى تحديد مصادر الإجهاد في مكان العمل ومعالجتها لتعزيز الصحة النفسية لموظفيهم وقدرتهم على الموازنة بين العمل والحياة.<br><br>كما يمكن أن تؤثر الضغوطات المرتبطة بالعمل على مشاعر الموظف، مما قد يؤدي إلى ظهور العديد من المشاكل النفسية، مثل القلق والاكتئاب وحتى الإرهاق. ويمكن للمؤسسات تحسين مستوى رضا الموظفين وتعزيز الإنتاجية وتقليل التغيب عن العمل عن طريق إعطاء الأولوية للتوازن بين العمل والحياة والصحة النفسية. وقد تبين أن المؤسسات التي لا تعطي الأولوية للصحة النفسية لموظفيها تخاطر بتركهم مرهقين شعورياً وغير مبالين تجاه عملهم.</p>"
      }
    ]
  },
  {
    "key": "txtPhysicalWellbeingVPOOREXPDescription",
    "text": "<p>Physical well-being is the state of optimal physical health and wellness for employees, encompassing the body's overall health and functionality. It covers various elements such as proper nutrition, regular exercise, adequate sleep, and preventative healthcare. The existing design of the workplace and policies can nudge employees toward or away from their physical well-being. Physical Well-being assesses the physical safety and health of employees at their workplace. Employees' physical well-being is essential for a business's success and productivity because it directly affects their ability to perform their duties effectively and efficiently. <br><br>Additionally, physically well employees are more likely to be engaged and motivated, increasing productivity and job satisfaction. In the long term, investing in the physical well-being of employees can also lead to lower healthcare costs and a reduction in absenteeism. Organizations with low score must investigate how their workplace design, policies, and procedures can negatively impact physical well-being. For example, poor ergonomics, such as poorly designed desks and chairs, can lead to musculoskeletal problems like back pain, neck pain, and carpal tunnel syndrome. Poor lighting and ventilation can also contribute to physical issues, such as eye strain and headaches. Specific policies and procedures can negatively impact physical well-being. A culture that discourages taking breaks can lead to fatigue and burnout. Similarly, a lack of flexibility in the work schedule can cause physical health problems. The organization should be mindful of these factors and make necessary adjustments to promote their employees' physical well-being.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير الرفاهية من الناحية البدنية (الصحية) إلى حالة الصحة الجسدية والعافية المثلى للموظفين، وذلك يشمل عناصر مختلفة مثل التغذية السليمة، وممارسة التمارين الرياضية بانتظام، والنوم الكافي، والرعاية الصحية الوقائية. ويمكن للتصميم الحالي لمكان العمل والسياسات المتبعة فيه أن ترقى بالموظفين نحو رفاهيتهم الصحية أو تأخذهم بعيداً عن تلك الرفاهية. وتقيّم الرفاهية الصحية مدى السلامة البدنية وصحة الموظفين في مكان عملهم. وتعتبر الرفاهية الصحية للموظفين ضرورية لنجاح الأعمال وإنتاجية الموظفين، لأنها تؤثر وبشكل مباشر على قدرتهم على أداء التزاماتهم بفعالية وكفاءة. بالإضافة إلى ذلك، فإنه من المرجح أن يكون الموظفون الذين يتمتعون بصحة جيدة بدنياً أكثر اندماجاً وتحفيزاً، مما يزيد من الإنتاجية والرضا الوظيفي، ويمكن أن يؤدي الاستثمار في الرفاهية الصحية للموظفين إلى انخفاض تكاليف الرعاية الصحية وتقليل التغيب عن العمل على المدى الطويل.<br><br>ويجب على المؤسسات ذات الدرجات المنخفضة في هذا الجانب التحقق من كيفية تأثير تصميم مكان العمل والسياسات والإجراءات المتبعة بشكل سلبي على الرفاهية الصحية للموظفين، على سبيل المثال، يمكن أن تؤدي بيئة العمل السيئة، مثل المكاتب والكراسي سيئة التصميم، إلى حدوث مشاكل في العضلات والعظام مثل آلام الظهر، وآلام الرقبة، ومتلازمة النفق الرسغي، كما يمكن أن يساهم ضعف الإضاءة والتهوية في حدوث مشكلات جسدية، مثل إجهاد العين والصداع، كما يمكن لبعض السياسات والإجراءات أن تؤثر سلباً على الرفاهية الموظفين في هذا المنطلق. هذا وكما يمكن أن تؤدي الثقافة التي لا تشجع على أخذ فترات راحة إلى الإجهاد والإرهاق، وبالمثل، فإن عدم وجود مرونة في جدول العمل يمكن أن يسبب مشاكل صحية بدنية، لذلك يجب على أرباب العمل أن يضعوا في اعتبارهم هذه العوامل وأن يقوموا بالتعديلات اللازمة لتعزيز الصحة البدنية لموظفيهم.</p>"
      }
    ]
  },
  {
    "key": "txtDimensionsofWorkplaceWellbeingDesc",
    "text": "The below indicates the scores for each of the [Dimensions Count] dimensions of Workplace Employee Well-Being at [Company Name]:",
    "translations": [
      {
        "language": "AR",
        "text": "يشير ما  يلي إلى الدرجات لكل بُعد من أبعاد رفاهية الموظف في الشركة:"
      }
    ]
  },
  {
    "key": "txtDimensionsOfWorkplaceWellbeing",
    "text": "Employee Well-Being Dimensions ",
    "translations": [
      {
        "language": "AR",
        "text": "أبعاد رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtEmployeesWellbeingIndexpara",
    "text": "The Employee Well-being Index indicates the overall well-being of respondents in the company. The Data below exhibits the percentage of respondents with very high, high, moderate, low, and very low well-being based on their responses to the various dimensions of Employee Well-being.",
    "translations": [
      {
        "language": "AR",
        "text": "وتمثل مؤشرات رفاهية الموظفين المستوى التالي من درجة الرفاهية في مكان العمل. وتعرض النتائج أدناه النسب المئوية للموظفين الذين يتمتعون برفاهية مرتفعة للغاية، مرتفعة، معتدلة، منخفضة منخفضة للغاية بناءً على ردودهم على أبعاد رفاهية الموظف المختارة."
      }
    ]
  },
  {
    "key": "txtEmployeesWellbeingIndex",
    "text": "Employee Well-being Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceWellbeingpara1",
    "text": "The Workplace Well-being Score represents the respondents' overall perception of their workplace well-being. It is the average score of the respondents to the selected dimensions of Employee Well-being.",
    "translations": [
      {
        "language": "AR",
        "text": "تعبر نتيجة رفاهية الموظف في مكان العمل عن التصور والرفاهية الكلية. وهي تشكل المعدل الكلي لنتائج أبعاد رفاهية الموظف المختارة."
      }
    ]
  },
  {
    "key": "txtOverallWorkplaceWellbeing",
    "text": "Overall Workplace Well-Being Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتيجة رفاهية الموظف الكلي في مكان العمل"
      }
    ]
  },
  {
    "key": "txtCalculationProcess4",
    "text": "The overall score for each dimension can help companies understand what measures they need to take to improve employee well-being.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكن للنتيجة الإجمالية لكل بُعد مساعدة الشركات على فهم التدابير التي يتعين عليهم اتخاذها لتحسين رفاهية الموظفين."
      }
    ]
  },
  {
    "key": "txtCalculationProcess3",
    "text": "The overall score for each dimension gives the average response of the employees for that dimension.",
    "translations": [
      {
        "language": "AR",
        "text": "تعطي الدرجة الإجمالية لكل بُعد متوسط استجابة الموظفين لهذا البعد."
      }
    ]
  },
  {
    "key": "txtCalculationProcess2",
    "text": "\"Very Low\" means that the current workplace, culture, and practices are not employee friendly and may even endanger employee well-being. In contrast, \"Very High\" means that the contemporary workplace, culture, and practices are significantly employee friendly and that the company takes employee well-being seriously.",
    "translations": [
      {
        "language": "AR",
        "text": "وتعني كلمة \"منخفض للغاية\" أن مكان العمل الحالي والثقافة والممارسات ليست محببة للموظفين، بل وقد تعرض رفاهية الموظف للخطر. وفي المقابل، تعني كلمة \"مرتفع للغاية\" أن مكان العمل والثقافة والممارسات الحالية محببة للموظفين بشكل كبير، وأن الشركة تأخذ رفاهية الموظفين على محمل الجد."
      }
    ]
  },
  {
    "key": "txtCalculationProcess1",
    "text": "The overall employee well-being score of the organization ranges from Very Low, Low, Moderate, High, to Very High.",
    "translations": [
      {
        "language": "AR",
        "text": "تتراوح النتيجة الإجمالية لرفاهية الموظف في الشركة من منخفض للغاية، منخفض، معتدل، مرتفع إلى مرتفع للغاية."
      }
    ]
  },
  {
    "key": "txtCalculationProcess",
    "text": "Calculation Process",
    "translations": [
      {
        "language": "AR",
        "text": "عملية الحساب"
      }
    ]
  },
  {
    "key": "txtResultsRating",
    "text": "Results Rating",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس النتائج"
      }
    ]
  },
  {
    "key": "txtHowtousethisreportpara",
    "text": "<p>Employee Well-being scores displayed in this report indicate the overall scores of the employees in the company. <br><br>The Recommended actions in this report are only some of the many activities that can improve employee well-being in the workplace. They are not limited to the displayed suggestions.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير درجات رفاهية الموظف المعروضة في هذا التقرير إلى الدرجات الإجمالية للموظفين في الشركة.  <br><br> وجدير بالذكر أن الإجراءات الموصى بها لتعزيز رفاهية الموظف غير مقتصرة على الاقتراحات المعروضة في هذا التقرير، بل هي أمثلة عن بعض الأنشطة من أصل أنشطة أخرى متعددة والتي من شأنها تعزيز رفاهية الموظف في مكان العمل.</p>"
      }
    ]
  },
  {
    "key": "txtHowtousethisreport",
    "text": "How to Use the Report",
    "translations": [
      {
        "language": "AR",
        "text": "كيف يمكن الاستفادة من التقرير؟"
      }
    ]
  },
  {
    "key": "txtZenWellbeingDimensionsPara",
    "text": "<p>Even when the company has good intentions, current workplace practices, policies, and culture sometimes negatively impact employee well-being. <br><br>Zenithr's team has designed its Employee Well-being based on the industry's latest thought leadership and research. Zenithr's team uses a design thinking approach to help companies prioritize and improve employee well-being.<br><br>Improving one dimension can simultaneously improve other dimensions. The companies can first prioritize dimensions with low scores, as presented in the report.  </p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>إن ممارسات وسياسات وثقافة مكان العمل الحالية - حتى عندما يكون لدى المؤسسة نوايا حسنة - تؤثر سلباً في بعض الأحيان على رفاهية الموظف. <br><br>وقد قام فريق زينثر بتصور وتصميم رفاهية الموظفين بناءً على أحدث التطورات والأبحاث الرائدة في هذا المجال. ويستخدم فريق زينثر نهج التفكير التصميمي لمساعدة المؤسسات على إعطاء الأولوية لرفاهية موظفيها وتحسينها باستمرار.<br><br>وجدير بالذكر أنه يمكن لتحسين أحد الأبعاد أن يؤدي إلى تحسين الأبعاد الأخرى في ذات الوقت، لذلك يمكن للمؤسسات  البدء بإعطاء الأولوية للأبعاد ذات الدرجات المنخفضة، كما سيتم ذكره في التقرير.   </p>"
      }
    ]
  },
  {
    "key": "txtZenWellbeingDimensions",
    "text": "Zenithr Employee Well-Being Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "أبعاد رفاهية الموظف الخاصة ب زينثر"
      }
    ]
  },
  {
    "key": "txtobjectives",
    "text": "<h4 class=\"mb-5 text-zen text-lg font-semibold mt-12\">Objectives of this Report</h4><div class=\"flex flex-col items-stretch gap-2\"><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>Identify and understand how employees perceive their well-being across various dimensions.</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>Obtain open-ended responses and employees' feedback to maintain and support their well-being in the workplace.</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>Address areas of improvement (based on dimensions with low scores).</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>Provide recommendations for the company to maintain and enhance well-being at work.</p></div></div>",
    "translations": [
      {
        "language": "AR",
        "text": "<h4 class=\"mb-5 text-zen text-lg font-semibold mt-12\">أهداف التقرير</h4><div class=\"flex flex-col items-stretch gap-2\"><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>تحديد وفهم كيفية إدراك الموظفين لمفهوم رفاهيتهم عبر أبعاد مختلفة.</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>الحصول على ردود وملاحظات واضحة من الموظفين للحفاظ على رفاهيتهم في مكان العمل ودعمه.</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>معالجة مجالات تحسين العمل (بناءً على أبعاد ذات درجات منخفضة)</p></div><div class=\"flex flex-row gap-2\"><i class=\"fas fa-circle text-exp leading-6 text-xs\"></i><p>تقديم توصيات للشركة للحفاظ على الرفاهية في العمل وتعزيزها.</p></div></div>"
      }
    ]
  },
  {
    "key": "txtIntroductionpara",
    "text": "<p>Employee well-being refers to the overall quality of life an employee experiences when employed with a company. <br><br> Zenithr Employee Well-being Survey measures employees' well-being across five dimensions - physical, psychological, social, occupational, and financial. Companies prioritizing employee well-being can reduce employee burnout, turnover, expenditure on healthcare, disengagement, presenteeism, and absenteeism. They can also improve the overall health of their employees, the organization's productivity, tolerance for change, and culture. <br><br> Zenithr Well-being survey gives organizations an overview of how they impact their employees' well-being. The results may help them to identify, design, and make relevant changes to the workplace to make it employee friendly.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>تشير رفاهية الموظف إلى جودة حياة العمل التي يعيشها الموظف عند عمله لدى المؤسسة. <br><br>ويقاس استبيان زينيثر الخاص برفاهية الموظف عن طريق التركيز على خمسة أبعاد أساسية - جسدية ونفسية واجتماعية ومهنية ومالية. ويمكن للمؤسسات التي تعطي الأولوية لرفاهية الموظفين أن تقلل من معدل إجهاد الموظفين، ومن التدوير الوظيفي، ومصروفات الرعاية الصحية، وعدم الاندماج في العمل، والتعذر والتغيب عن العمل. كما يمكنهم أيضاً تحسين الوضع الصحي العام لموظفيهم، وتحسين إنتاجية المؤسسة، و ثقافتها المؤسسية، وقدرتها على التكيف مع التغيير.<br><br>ويعطي استبيان رفاهية الموظف المُطوّر من قبل زينثر للمؤسسات لمحة عامة عن مدى تأثيرهم على رفاهية موظفيهم. وقد تساعدهم النتائج على تحديد وتصميم وإجراء التغييرات ذات الصلة في مكان العمل لجعله محبباً للموظفين.</p>"
      }
    ]
  },
  {
    "key": "txtIntroduction",
    "text": "Introduction",
    "translations": [
      {
        "language": "AR",
        "text": "مقدمة"
      }
    ]
  },
  {
    "key": "txtWellbeingReport",
    "text": "Employee Well-Being  Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txttableofcontents",
    "text": "Table of Contents",
    "translations": [
      {
        "language": "AR",
        "text": "جدول المحتويات"
      }
    ]
  },
  {
    "key": "txtConfidential",
    "text": "Confidential",
    "translations": [
      {
        "language": "AR",
        "text": "خاص وسري"
      }
    ]
  },
  {
    "key": "txtEmployeeWellbeing",
    "text": "Employee Well-Being",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txt_report",
    "text": "Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير"
      }
    ]
  },
  {
    "key": "txt_download_comments",
    "text": "Download Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التعليفات"
      }
    ]
  },
  {
    "key": "txtWellbeingComparison",
    "text": "Wellbeing Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtSurveysByCompany",
    "text": "Surveys By Company",
    "translations": [
      {
        "language": "AR",
        "text": "الاستبيانات حسب الشركة"
      }
    ]
  },
  {
    "key": "txtAveraged",
    "text": "Averaged",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      }
    ]
  },
  {
    "key": "txtSelected",
    "text": "Selected",
    "translations": [
      {
        "language": "AR",
        "text": "الشركات المختارة"
      }
    ]
  },
  {
    "key": "txt_end_date",
    "text": "End Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء"
      }
    ]
  },
  {
    "key": "txtOverallResponseRate",
    "text": "Overall Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة العام"
      }
    ]
  },
  {
    "key": "txtStatusAnalysis",
    "text": "Respondents by Status Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل حالة المستجيبون"
      }
    ]
  },
  {
    "key": "txtRespby",
    "text": "Respondents by",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب"
      }
    ]
  },
  {
    "key": "txtMean",
    "text": "Mean",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      }
    ]
  },
  {
    "key": "txt_Generated_142",
    "text": "Generated Link",
    "translations": [
      {
        "language": "AR",
        "text": "الرابط المنشئ"
      }
    ]
  },
  {
    "key": "WB:2003",
    "text": "Link has already been sent to the user.",
    "translations": [
      {
        "language": "AR",
        "text": "تم مشاركة الرابط مع المستجيب"
      }
    ]
  },
  {
    "key": "txt_remove_criteria_confirmation_message",
    "text": "Are you sure you want to delete this criteria?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذه المعايير؟"
      }
    ]
  },
  {
    "key": "txtAnalysisSection",
    "text": "Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات"
      }
    ]
  },
  {
    "key": "txtMaximum",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "الأكثر"
      }
    ]
  },
  {
    "key": "txtMedian",
    "text": "Median",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      }
    ]
  },
  {
    "key": "txtMinimum",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "الأقل"
      }
    ]
  },
  {
    "key": "txtHeatmap",
    "text": "Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "مخطط تمثيل البيانات بالألوان"
      }
    ]
  },
  {
    "key": "txtheatmaptooltip",
    "text": "The value displayed in the cell is delta, which represents a difference in the overall value.",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم المكتوب داخل المربع يمثل الفرق بين النتيجة والمعدل الكلي."
      }
    ]
  },
  {
    "key": "txtComparisonOverall",
    "text": "Comparison: Overall",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة بالنسبة إلى: الكل"
      }
    ]
  },
  {
    "key": "txtRespondentsBy",
    "text": "Respondents By",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب"
      }
    ]
  },
  {
    "key": "txtByCriteria",
    "text": "By Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "حسب المعايير"
      }
    ]
  },
  {
    "key": "txtBreakout",
    "text": "Breakout:",
    "translations": [
      {
        "language": "AR",
        "text": "تفصيل حسب:"
      }
    ]
  },
  {
    "key": "txtbydimensions",
    "text": "By Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "حسب الأبعاد"
      }
    ]
  },
  {
    "key": "VGOODEXP",
    "text": "Very High",
    "translations": [
      {
        "language": "AR",
        "text": "مرتفع للغاية"
      }
    ]
  },
  {
    "key": "GOODEXP",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "مرتفع"
      }
    ]
  },
  {
    "key": "FAIREXP",
    "text": "Moderate",
    "translations": [
      {
        "language": "AR",
        "text": "معتدل"
      }
    ]
  },
  {
    "key": "POOREXP",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "منخفض"
      }
    ]
  },
  {
    "key": "VPOOREXP",
    "text": "Very Low",
    "translations": [
      {
        "language": "AR",
        "text": "منخفض للغاية"
      }
    ]
  },
  {
    "key": "txtWellbeingIndexByScale",
    "text": "Employee Well-being Index",
    "translations": [
      {
        "language": "AR",
        "text": "مؤشر رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txt_dimensions_score",
    "text": "Dimensions Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الأبعاد"
      }
    ]
  },
  {
    "key": "txtNA",
    "text": "N/A",
    "translations": [
      {
        "language": "AR",
        "text": "لا ينطبق"
      }
    ]
  },
  {
    "key": "txtGlobal",
    "text": "Global",
    "translations": [
      {
        "language": "AR",
        "text": "العالمي"
      }
    ]
  },
  {
    "key": "txt_TopPerfor_672",
    "text": "Top Performers",
    "translations": [
      {
        "language": "AR",
        "text": "أفضل أداء"
      }
    ]
  },
  {
    "key": "txtOverall",
    "text": "Overall",
    "translations": [
      {
        "language": "AR",
        "text": "بشكل عام"
      }
    ]
  },
  {
    "key": "txtBenchmarks",
    "text": "Benchmarks",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير"
      }
    ]
  },
  {
    "key": "txt_Workplace_Wellbeing_Score",
    "text": "Workplace Well-being",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية مكان العمل"
      }
    ]
  },
  {
    "key": "txt_completed",
    "text": "Completed",
    "translations": [
      {
        "language": "AR",
        "text": "مكتمل"
      }
    ]
  },
  {
    "key": "txtof",
    "text": "of",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      }
    ]
  },
  {
    "key": "txtExtraDriver",
    "text": "Extra Dimension",
    "translations": [
      {
        "language": "AR",
        "text": "بُعد الرفاهية الإضافي"
      }
    ]
  },
  {
    "key": "preparingReport",
    "text": "Preparing Report",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير التقرير"
      }
    ]
  },
  {
    "key": "txtViewBy",
    "text": "View By",
    "translations": [
      {
        "language": "AR",
        "text": "تصفح عن طريق"
      }
    ]
  },
  {
    "key": "txtComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      }
    ]
  },
  {
    "key": "txt_questions",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      }
    ]
  },
  {
    "key": "txtResponses",
    "text": "Respondent Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل المستجيبون"
      }
    ]
  },
  {
    "key": "txtOverview",
    "text": "Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة"
      }
    ]
  },
  {
    "key": "btn_back",
    "text": "Back",
    "translations": [
      {
        "language": "AR",
        "text": "عودة"
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_message",
    "text": "Are you sure you want to delete this survey?",
    "translations": [
      {
        "language": "AR",
        "text": "هل انت متأكد من حذف هذا الاسبيان؟"
      }
    ]
  },
  {
    "key": "txt_questionnaire_name",
    "text": "Survey Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الاستبيان"
      }
    ]
  },
  {
    "key": "txtAllRights",
    "text": "All Rights Reserved\t",
    "translations": [
      {
        "language": "AR",
        "text": "جميع الحقوق محفوظة"
      }
    ]
  },
  {
    "key": "btn_preview_survey",
    "text": "Preview Survey",
    "translations": [
      {
        "language": "AR",
        "text": "عرض الاستبيان"
      }
    ]
  },
  {
    "key": "txtWellbeingSurveyPreview",
    "text": "Well-Being Survey Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض استبيان رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtRespondentsByStatus",
    "text": "RESPONDENTS BY STATUS",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الحالة"
      }
    ]
  },
  {
    "key": "txt_response_rate",
    "text": "Response Rate\t",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة"
      }
    ]
  },
  {
    "key": "txtReminderSent",
    "text": "Reminders has been sent.",
    "translations": [
      {
        "language": "AR",
        "text": "تم إرسال التذكيرات."
      }
    ]
  },
  {
    "key": "txt_employee_WellbeingSurvey",
    "text": "Employee Well-being Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txt_questionnaire_welcome",
    "text": "<p>Thank you for taking the time to fill out the Employee Well-being survey. Your honest feedback is highly appreciated. Please note that your responses are strictly confidential, and your identity shall remain anonymous throughout the entire process. However, the results of the survey will be used for research and improvement purposes by the Human Resources Team.<br><br> Disclaimer: All information pertaining to this survey shall remain anonymous and shall not be disclosed to anyone.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>نشكرك لمشاركتك في هذا الاستبيان. أجوبتك النزيهة والصريحة مهمة لنا. يرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا الاستبيان سرية للغاية وستبقى هويتك مجهولة. وتستخدم هذه النتائج فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية.<br><br> إخلاء المسؤولية: جميع المعلومات المتعلقة بهذا الاستبيان سرية ولن يتم الإفصاح عنها لأي جهة.</p>"
      }
    ]
  },
  {
    "key": "txt_survey_title",
    "text": "Employee Well-being",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية الموظف"
      }
    ]
  },
  {
    "key": "txtSendEmails",
    "text": "Send Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال تذكيرات"
      }
    ]
  },
  {
    "key": "txtProvideEndDate",
    "text": "You need to provide an end date.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إدخال تاريخ الإكمال."
      }
    ]
  },
  {
    "key": "txt_go_closed",
    "text": "This survey will now be closed and you will no longer be able to make any changes or add new respondents.\t",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم إنهاء هذا الاستبيان الآن ولن تتمكن بعد ذلك من إجراء أي تغيير أو إضافة مستجيبين."
      }
    ]
  },
  {
    "key": "txt_Atleast3r_677",
    "text": "At least 3 respondents should complete the survey in order to close it\t",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استكمال الاستبيان من قبل 3 من المستجيبين على الأقل من أجل إغلاقه"
      }
    ]
  },
  {
    "key": "txtRemindersBulkSend",
    "text": "Reminders will be sent to total #count respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "سيتم إرسال التذكيرات ل #count مستجيب."
      }
    ]
  },
  {
    "key": "txtSelectAllRespondentsFromPages",
    "text": "Select all respondents from all pages?",
    "translations": [
      {
        "language": "AR",
        "text": "اختر  كل المستجيبين من كافة الصفحات؟"
      }
    ]
  },
  {
    "key": "txtSelectedRespondentsOnPage",
    "text": "#count respondents on this page are selected.",
    "translations": [
      {
        "language": "AR",
        "text": "تم اختيار #count مستجيب من هذه الصفحة."
      }
    ]
  },
  {
    "key": "txtAllRespondentsFromPages",
    "text": "All #count respondents from all pages are selected.",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد #count المستجيبين من كافة الصفحات."
      }
    ]
  },
  {
    "key": "txtSelectedSurveysOnPage",
    "text": "#count draft surveys on this page are selected.",
    "translations": [
      {
        "language": "AR",
        "text": "تم #count تحديد مسودة على هذه الصفحة."
      }
    ]
  },
  {
    "key": "txtSelectAllFromPages",
    "text": "Select all #count draft surveys from all pages?",
    "translations": [
      {
        "language": "AR",
        "text": "هل تريد تحديد #count  مسودة من كافة الصفحات؟"
      }
    ]
  },
  {
    "key": "txt_ClearSele_284",
    "text": "Clear Selection",
    "translations": [
      {
        "language": "AR",
        "text": " مسح كافة التحديدات"
      }
    ]
  },
  {
    "key": "txtAllSurveysSelected",
    "text": "All #count surveys from all pages are selected. ",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد #count الاستبيانات من كافة الصفحات"
      }
    ]
  },
  {
    "key": "txt_remove_respondents_confirmation_message",
    "text": "Are you sure you want to delete these respondents?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هؤلاء المستجيبون؟"
      }
    ]
  },
  {
    "key": "txt_ShareSurv_665",
    "text": "Share Survey",
    "translations": [
      {
        "language": "AR",
        "text": "مشاركة الاستبيان"
      }
    ]
  },
  {
    "key": "txt_DeleteSel_329",
    "text": "Delete Selected",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      }
    ]
  },
  {
    "key": "txt_respondents_list",
    "text": "Respondents List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة المستجيبون"
      }
    ]
  },
  {
    "key": "txt_remove_respondent_confirmation_message",
    "text": "Are you sure you want to delete this respondent?\t",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من حذف هذا المستجيب؟"
      }
    ]
  },
  {
    "key": "txt_send_reminder",
    "text": "Send Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكير"
      }
    ]
  },
  {
    "key": "txt_NewRespon_215",
    "text": "Add Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      }
    ]
  },
  {
    "key": "txt_Share_429",
    "text": "Share",
    "translations": [
      {
        "language": "AR",
        "text": "شارك"
      }
    ]
  },
  {
    "key": "txt_CloseNow_473",
    "text": "Close Now",
    "translations": [
      {
        "language": "AR",
        "text": "أغلق الآن"
      }
    ]
  },
  {
    "key": "txtLive",
    "text": "Live",
    "translations": [
      {
        "language": "AR",
        "text": "مباشر"
      }
    ]
  },
  {
    "key": "txtExport",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "txt_Searchres_762",
    "text": "Search respondents...",
    "translations": [
      {
        "language": "AR",
        "text": "بحث..."
      }
    ]
  },
  {
    "key": "txt_multiple_reminders",
    "text": "Multiple Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "تذكيرات متعددة"
      }
    ]
  },
  {
    "key": "txt_no_reminders",
    "text": "No reminders have been created.\t",
    "translations": [
      {
        "language": "AR",
        "text": "لا يوجد أية تذكيرات تم ضبطها حتى الآن!"
      }
    ]
  },
  {
    "key": "txt_DeleteQue_565",
    "text": "Delete Statement",
    "translations": [
      {
        "language": "AR",
        "text": "حذف العبارة"
      }
    ]
  },
  {
    "key": "txt_delete_item_confirmation_message",
    "text": "Are you sure you want to permanently remove this item?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذا العنصر نهائياً؟"
      }
    ]
  },
  {
    "key": "txt_NewQuesti_189",
    "text": "New Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      }
    ]
  },
  {
    "key": "txt_newstatem_408",
    "text": "New Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة جديدة"
      }
    ]
  },
  {
    "key": "txt_survey_questions",
    "text": "Survey Questions",
    "translations": [
      {
        "language": "AR",
        "text": "أسئلة الاستبيان"
      }
    ]
  },
  {
    "key": "txt_Selectall_272",
    "text": "Select all",
    "translations": [
      {
        "language": "AR",
        "text": "تحديد الكل"
      }
    ]
  },
  {
    "key": "txtGenerated",
    "text": "Generated",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاءه في"
      }
    ]
  },
  {
    "key": "txtPoweredby",
    "text": "Powered by:",
    "translations": [
      {
        "language": "AR",
        "text": "مشغّل بواسطة"
      }
    ]
  },
  {
    "key": "btn_close",
    "text": "Close",
    "translations": [
      {
        "language": "AR",
        "text": "إغلاق"
      }
    ]
  },
  {
    "key": "btn_edit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      }
    ]
  },
  {
    "key": "txtDriverName",
    "text": "Dimension Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم البعد"
      }
    ]
  },
  {
    "key": "txt_Atleaston_223",
    "text": "At least one statement needs to be added",
    "translations": [
      {
        "language": "AR",
        "text": "يجب إضافة عبارة واحدة على الأقل"
      }
    ]
  },
  {
    "key": "txt_Dimension_242",
    "text": "Dimensions can't be more than 8",
    "translations": [
      {
        "language": "AR",
        "text": "الأبعاد يجب ألا تزيد عن 8!"
      }
    ]
  },
  {
    "key": "txt_Dimension_415",
    "text": "At least 3 predefined dimensions must be selected!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب اختيار 3 أبعاد على الأقل!"
      }
    ]
  },
  {
    "key": "txt_inthispag_314",
    "text": "in this page have been selected. ",
    "translations": [
      {
        "language": "AR",
        "text": "تم اختيار عناصر في هذه الصفحة"
      }
    ]
  },
  {
    "key": "txt_Allitemsh_336",
    "text": "All items have been selected.",
    "translations": [
      {
        "language": "AR",
        "text": "تم تحديد كافة العناصر"
      }
    ]
  },
  {
    "key": "txt_BACKTOSUR_422",
    "text": "BACK",
    "translations": [
      {
        "language": "AR",
        "text": "الرجوع"
      }
    ]
  },
  {
    "key": "txt_invitation_email",
    "text": "Invitation Email",
    "translations": [
      {
        "language": "AR",
        "text": "دعوة لاستكمال الاستبيان"
      }
    ]
  },
  {
    "key": "txt_timeframe",
    "text": "Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "txt_respondents",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون"
      }
    ]
  },
  {
    "key": "txt_analytical_criteria",
    "text": "Analytical Criteria",
    "translations": [
      {
        "language": "AR",
        "text": "المعايير التحليلية"
      }
    ]
  },
  {
    "key": "txt_survey_setup",
    "text": "Survey Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد الاستبيان"
      }
    ]
  },
  {
    "key": "txtAtLeastRespondents",
    "text": "At least 3 respondents are needed to submit the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "يجب استكمال الاستبيان من قبل 3 من المستجيبين على الأقل من أجل إغلاقه"
      }
    ]
  },
  {
    "key": "txt_added_success",
    "text": "Added Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تمت الإضافة بنجاح!"
      }
    ]
  },
  {
    "key": "txt_updated_success",
    "text": "Updated Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم التحديث بنجاح!"
      }
    ]
  },
  {
    "key": "txt_removed_success",
    "text": "Deleted Successfully!\t",
    "translations": [
      {
        "language": "AR",
        "text": "تم الحذف بنجاح!"
      }
    ]
  },
  {
    "key": "txt_Pleaseimp_478",
    "text": "Please import valid .xlsx file.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى استيراد ملف .xlsx صالح."
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      }
    ]
  },
  {
    "key": "txt_okay_action",
    "text": "Okay",
    "translations": [
      {
        "language": "AR",
        "text": "حسناً"
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_subject",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      }
    ]
  },
  {
    "key": "txtHavemorecomments",
    "text": "Have more comments?",
    "translations": [
      {
        "language": "AR",
        "text": "لديك المزيد من التعليقات؟"
      }
    ]
  },
  {
    "key": "txtExtraQuestion",
    "text": "I feel motivated and inspired at the workplace",
    "translations": [
      {
        "language": "AR",
        "text": "أشعر بالتحفيز والإلهام في بيئة العمل"
      }
    ]
  },
  {
    "key": "txt_preview_sample_desc",
    "text": "Question Preview",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج عرض لسؤال الاستبيان."
      }
    ]
  },
  {
    "key": "txt_Sample_Question",
    "text": "Sample Question",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج السؤال"
      }
    ]
  },
  {
    "key": "txtExtraQuestionPreview",
    "text": "Question Preview",
    "translations": [
      {
        "language": "AR",
        "text": "عرض السؤال"
      }
    ]
  },
  {
    "key": "txt_survey_info",
    "text": "Survey Information",
    "translations": [
      {
        "language": "AR",
        "text": "معلومات الاستبيان"
      }
    ]
  },
  {
    "key": "txt_Addupto4s_862",
    "text": "Add up to 4 statements\t",
    "translations": [
      {
        "language": "AR",
        "text": "أضف ما يصل إلى 4 عبارات"
      }
    ]
  },
  {
    "key": "txt_NewCustom_150",
    "text": "New Custom Dimension",
    "translations": [
      {
        "language": "AR",
        "text": "بعد مخصص جديد"
      }
    ]
  },
  {
    "key": "txt_STATEMENT_772",
    "text": "Statements of",
    "translations": [
      {
        "language": "AR",
        "text": "عبارات ل"
      }
    ]
  },
  {
    "key": "txt_Selectupt_657",
    "text": "Select up to 8 Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "حدد ما يصل إلى 8 أبعاد"
      }
    ]
  },
  {
    "key": "txt_Optional_264",
    "text": "Optional",
    "translations": [
      {
        "language": "AR",
        "text": "اختياري"
      }
    ]
  },
  {
    "key": "txt_Descripti_202",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "txtCustomDimensions",
    "text": "Custom Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "أبعاد مخصصة"
      }
    ]
  },
  {
    "key": "txtDimensions",
    "text": "Predefined Dimensions",
    "translations": [
      {
        "language": "AR",
        "text": "أبعاد مُعرفة مسبقاً"
      }
    ]
  },
  {
    "key": "txt_SurveyLis_133",
    "text": " Survey List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الاستبيانات"
      }
    ]
  },
  {
    "key": "txtRename",
    "text": "Rename",
    "translations": [
      {
        "language": "AR",
        "text": "إعادة تسمية"
      }
    ]
  },
  {
    "key": "btn_delete",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      }
    ]
  },
  {
    "key": "txt_NewSetup_163",
    "text": "New Setup",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد جديد"
      }
    ]
  },
  {
    "key": "txt_Search_185",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      }
    ]
  },
  {
    "key": "txt_DateCreat_677",
    "text": "Date Created",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإنشاء"
      }
    ]
  },
  {
    "key": "txt_SurveyTit_804",
    "text": "Survey Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان الاستبيان"
      }
    ]
  },
  {
    "key": "txt_Status_579",
    "text": "Status",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      }
    ]
  },
  {
    "key": "txt_Workplace_928",
    "text": "Workplace Well-Being",
    "translations": [
      {
        "language": "AR",
        "text": "رفاهية مكان العمل"
      }
    ]
  },
  {
    "key": "txtAll",
    "text": "All",
    "translations": [
      {
        "language": "AR",
        "text": "الجميع"
      }
    ]
  },
  {
    "key": "btn_previous",
    "text": "Previous",
    "translations": [
      {
        "language": "AR",
        "text": "السابق"
      }
    ]
  },
  {
    "key": "btn_next",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "txt_send_invitations",
    "text": "Send Invitations",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      }
    ]
  },
  {
    "key": "btn_add_respondent",
    "text": "Add Respondent",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة مستجيب"
      }
    ]
  },
  {
    "key": "txt_set_timeframe",
    "text": "Set Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المدة الزمنية"
      }
    ]
  },
  {
    "key": "txt_start_date",
    "text": "Start Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء"
      }
    ]
  },
  {
    "key": "txt_completion_date",
    "text": "Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإكمال"
      }
    ]
  },
  {
    "key": "txt_set_reminders",
    "text": "Set Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "ضبط التذكيرات"
      }
    ]
  },
  {
    "key": "txt_add_reminder",
    "text": "Add Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة تذكير"
      }
    ]
  },
  {
    "key": "txt_reminder_date",
    "text": "Reminder Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ التذكير"
      }
    ]
  },
  {
    "key": "txt_multiple_reminders_description",
    "text": "Remind your respondents at preset times to fill the survey before the completion date.<br> Set a maximum of 3 Reminders from using the right interface.<br> Click the button below to edit the email template.",
    "translations": [
      {
        "language": "AR",
        "text": "ذكّر المستجيبين بتعبئة الاستبيان قبل موعد الانتهاء من خلال تذكيرات محددة مسبقًا. اضبط 3 تذكيرات كحد أقصى باستخدام الواجهة اليمنى. اضغط على الزر أدناه لتعديل البريد الالكتروني الخاص بالتذكير."
      }
    ]
  },
  {
    "key": "txt_reminder_template",
    "text": "Reminder Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج التذكير"
      }
    ]
  },
  {
    "key": "txtEmailTemplate",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الالكتروني"
      }
    ]
  },
  {
    "key": "txtEditSurvey",
    "text": "Edit Survey",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل الاستبيان"
      }
    ]
  },
  {
    "key": "txtTitle",
    "text": "Survey Title",
    "translations": [
      {
        "language": "AR",
        "text": "عنوان الاستبيان"
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": "Annuler "
      }
    ]
  },
  {
    "key": "btn_update",
    "text": "Update",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث"
      }
    ]
  },
  {
    "key": "txt_send_reminders",
    "text": "Send Reminders",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكيرات"
      }
    ]
  },
  {
    "key": "btn_save_reminder_template",
    "text": "Save Template",
    "translations": [
      {
        "language": "AR",
        "text": "حفظ نموذج التذكير"
      }
    ]
  },
  {
    "key": "AP_T_1_TITLE",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "AP_T_1_DESCRIPTION",
    "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to boost employee wellbeing.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة خطة العمل، يتم تحويل ملاحظات الموظفين إلى مبادرات واضحة وقابلة للتنفيذ. هنا يمكنك إنشاء خطتك، إعدادها، وإطلاقها لتعزيز مستوى رفاهية الموظف."
      }
    ]
  },
  {
    "key": "AP_T_2_TITLE",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      }
    ]
  },
  {
    "key": "AP_T_2_DESCRIPTION",
    "text": "Click here to filter and create an action plan for a selected entity or company-wide.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط هنا لاستخدام الفلاتر وإنشاء خطة عمل لجهة محددة أو على مستوى الشركة بالكامل."
      }
    ]
  },
  {
    "key": "AP_T_3_TITLE",
    "text": "Entity Selection – by Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الوحدة - جهة العمل"
      }
    ]
  },
  {
    "key": "AP_T_3_DESCRIPTION",
    "text": "Select the desired entity for your action plan by checking its box, then click Apply.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة المطلوبة لخطة العمل الخاصة بك عن طريق تحديد المربع بجانبها، ثم اضغط على تطبيق."
      }
    ]
  },
  {
    "key": "AP_T_4_TITLE",
    "text": "Crate Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء خطة العمل"
      }
    ]
  },
  {
    "key": "AP_T_4_DESCRIPTION",
    "text": "After selecting an entity or company-wide for your action plan, click Create Action Plan to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار الجهة محددة أو على مستوى الشركة لخطة العمل، اضغط على إنشاء خطة عمل للبدء."
      }
    ]
  },
  {
    "key": "AP_T_5_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_T_5_DESCRIPTION",
    "text": "Give your plan a clear, descriptive name to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "امنح خطتك عنوانًا واضحًا للبدء."
      }
    ]
  },
  {
    "key": "AP_T_6_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_T_6_DESCRIPTION",
    "text": "Add a brief description to explain the purpose and focus of your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف وصفًا موجزًا لشرح هدف وتركيز لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_T_7_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "AP_T_7_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      }
    ]
  },
  {
    "key": "AP_T_8_TITLE",
    "text": "Scope",
    "translations": [
      {
        "language": "AR",
        "text": "النطاق"
      }
    ]
  },
  {
    "key": "AP_T_8_DESCRIPTION",
    "text": "The “Scope” shows whether the action plan is applied organization-wide or to a specific business level.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض \"النطاق\" ما إذا كانت خطة العمل تنطبق على المنظمة بأكملها أو على مستوى عمل محدد."
      }
    ]
  },
  {
    "key": "AP_T_9_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة"
      }
    ]
  },
  {
    "key": "AP_T_9_DESCRIPTION",
    "text": "Choose the start and end dates for your action plan and then click on continue.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر تاريخ البدء وتاريخ الانتهاء لخطة العمل الخاصة بك، ثم اضغط على متابعة."
      }
    ]
  },
  {
    "key": "AP_T_10_TITLE",
    "text": "Action Plan List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة خطط العمل"
      }
    ]
  },
  {
    "key": "AP_T_10_DESCRIPTION",
    "text": "The action plan list displays all created action plans, showing their scope along with the number of focus areas, initiatives, and tasks.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض قائمة خطط العمل جميع الخطط التي تم إنشاؤها، موضحة نطاق كل منها وعدد مجالات التركيز والمبادرات والمهام."
      }
    ]
  },
  {
    "key": "AP_T_11_TITLE",
    "text": "Edit Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل خطط العمل"
      }
    ]
  },
  {
    "key": "AP_T_11_DESCRIPTION",
    "text": "Edit or delete the action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف خطط العمل."
      }
    ]
  },
  {
    "key": "AP_T_12_TITLE",
    "text": "Accessing Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "الوصول إلى خطة العمل"
      }
    ]
  },
  {
    "key": "AP_T_12_DESCRIPTION",
    "text": "To access an action plan, click Open.",
    "translations": [
      {
        "language": "AR",
        "text": "للوصول إلى خطة العمل، اضغط على فتح."
      }
    ]
  },
  {
    "key": "AP_T_13_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_T_13_DESCRIPTION",
    "text": "Select key dimensions or topics based on low scores and employee feedback to drive targeted improvements.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الابعاد أو المواضيع الرئيسية بناءً على النتائج المنخفضة وملاحظات الموظفين لدعم تحسينات موجهة وفعّالة."
      }
    ]
  },
  {
    "key": "AP_T_14_TITLE",
    "text": "Status Bar",
    "translations": [
      {
        "language": "AR",
        "text": "شريط الحالة"
      }
    ]
  },
  {
    "key": "AP_T_14_DESCRIPTION",
    "text": "View all selected focus areas, initiatives, and tasks in one place.",
    "translations": [
      {
        "language": "AR",
        "text": "هنا يتم عرض جميع مجالات التركيز والمبادرات والمهام المحددة في مكان واحد."
      }
    ]
  },
  {
    "key": "AP_T_15_TITLE",
    "text": "Dimension Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب الأبعاد"
      }
    ]
  },
  {
    "key": "AP_T_15_DESCRIPTION",
    "text": "Based on the selected well-being dimensions, choose the ones you want to focus on.\nNote: An upward arrow (↑) signifies high organizational impact, while a downward arrow (↓) indicates low impact.",
    "translations": [
      {
        "language": "AR",
        "text": "استنادًا إلى أبعاد الرفاهية المحددة، اختر الأبعاد التي ترغب في التركيز عليها.\nتلميح: يشير السهم للأعلى (↑) إلى تأثير مرتفع على المنظمة، بينما يشير السهم للأسفل (↓) إلى تأثير منخفض."
      }
    ]
  },
  {
    "key": "AP_T_16_TITLE",
    "text": "Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      }
    ]
  },
  {
    "key": "AP_T_16_DESCRIPTION",
    "text": "Once you’ve selected your focus area, choose the desired predefined initiative by checking the box next to it.\nNote: predefined initiatives cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد اختيار مجال التركيز، حدد المبادرة المعرفة مسبقًا عن طريق تحديد المربع بجانبها.\nتلميح: لا يمكن تعديل المبادرات المعرفة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_T_17_TITLE",
    "text": "Manual Initiative Entry",
    "translations": [
      {
        "language": "AR",
        "text": "إدخال المبادرة يدويًا"
      }
    ]
  },
  {
    "key": "AP_T_17_DESCRIPTION",
    "text": "You can also add initiatives manually.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك أيضًا إضافة المبادرات يدويًا."
      }
    ]
  },
  {
    "key": "AP_T_18_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_T_18_DESCRIPTION",
    "text": "Fill in your \"Initiative Title\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان المبادرة."
      }
    ]
  },
  {
    "key": "AP_T_19_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_T_19_DESCRIPTION",
    "text": "Fill in your \" Initiative Description\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة وصف المبادرة."
      }
    ]
  },
  {
    "key": "AP_T_20_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_T_20_DESCRIPTION",
    "text": "Set the due date for your initiative.\nNote: The due date cannot be later than the overall action plan due date.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ الإكمال المبادرة.\nتلميح: لا يمكن أن يكون تاريخ الإكمال للمبادرة بعد تاريخ إكمال خطة العمل الإجمالي."
      }
    ]
  },
  {
    "key": "AP_T_21_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_T_21_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nNote: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_T_22_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "AP_T_22_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “🌐”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      }
    ]
  },
  {
    "key": "AP_T_23_TITLE",
    "text": "AI-Generated Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_T_23_DESCRIPTION",
    "text": "Generate initiatives effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المبادرات بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      }
    ]
  },
  {
    "key": "AP_T_24_TITLE",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      }
    ]
  },
  {
    "key": "AP_T_24_DESCRIPTION",
    "text": "You can update your initiative details by clicking on the three vertical dots.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تعديل تفاصيل المبادرة بالضغط على النقاط الرأسية الثلاث."
      }
    ]
  },
  {
    "key": "AP_T_25_TITLE",
    "text": "Topic Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب الموضوع"
      }
    ]
  },
  {
    "key": "AP_T_25_DESCRIPTION",
    "text": "Topic-based Focus Areas, generated from employee comments, these topics highlight key concerns and show the number and distribution of positive, neutral, and negative comments.",
    "translations": [
      {
        "language": "AR",
        "text": "في مجالات التركيز حسب الموضوع، يتم إنشاء المواضيع من تعليقات الموظفين، حيث تسلط الضوء على أبرز الاهتمامات وتعرض عدد وتوزيع التعليقات الإيجابية والمحايدة والسلبية."
      }
    ]
  },
  {
    "key": "AP_T_26_TITLE",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة المهام يدويًا"
      }
    ]
  },
  {
    "key": "AP_T_26_DESCRIPTION",
    "text": "Add customized tasks based on your specific needs.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء مهام مخصصة وفقًا لاحتياجاتك."
      }
    ]
  },
  {
    "key": "AP_T_27_TITLE",
    "text": "AI-Generated Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_T_27_DESCRIPTION",
    "text": "Generate tasks effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المهام بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      }
    ]
  },
  {
    "key": "AP_T_28_TITLE",
    "text": "Launch",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق"
      }
    ]
  },
  {
    "key": "AP_T_28_DESCRIPTION",
    "text": "Once everything is set, click Launch to make your action plan live.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد الانتهاء من الإعدادات، اضغط على إطلاق لبدء خطة العمل."
      }
    ]
  },
  {
    "key": "AP_T_29_TITLE",
    "text": "Tracking",
    "translations": [
      {
        "language": "AR",
        "text": "التتبع"
      }
    ]
  },
  {
    "key": "AP_T_29_DESCRIPTION",
    "text": "View overall progress, task status, and key details such as Focus Areas, Initiatives, dates, and time remaining at a glance.",
    "translations": [
      {
        "language": "AR",
        "text": "اعرض مجالات التركيز والمبادرات والتواريخ والوقت المتبقي بنظرة سريعة."
      }
    ]
  },
  {
    "key": "AP_T_30_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_T_30_DESCRIPTION",
    "text": "Here you view the selected Focus Areas, whether Topics or Dimensions.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض مجالات التركيز المختارة، سواء كانت مواضيع أو الأبعاد."
      }
    ]
  },
  {
    "key": "AP_T_31_TITLE",
    "text": "Tasks Management",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة المهام"
      }
    ]
  },
  {
    "key": "AP_T_31_DESCRIPTION",
    "text": "Mark individual tasks as done using the checkbox, or finish all at once with Mark All as Complete.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المهام الفردية كمكتملة باستخدام المربع، أو قم بإكمال جميع المهام بالضغط على تحديد الكل كمكتمل."
      }
    ]
  },
  {
    "key": "AP_T_32_TITLE",
    "text": "Status Filter",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب الحالة"
      }
    ]
  },
  {
    "key": "AP_T_32_DESCRIPTION",
    "text": "You can filter initiatives by status: In Progress, Completed, or Expired.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك فرز المبادرات حسب الحالة: قيد التنفيذ مكتملة، أو منتهية."
      }
    ]
  },
  {
    "key": "AP_T_33_TITLE",
    "text": "Request for Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "طلب ملاحظات"
      }
    ]
  },
  {
    "key": "AP_T_33_DESCRIPTION",
    "text": "Click “Request Feedback” to invite employees to share their opinions and experiences regarding the implemented initiative, and measure its impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على طلب ملاحظات لدعوة الموظفين لمشاركة آرائهم وتجاربهم حول المبادرة المنفذة وقياس أثرها."
      }
    ]
  },
  {
    "key": "AP_T_34_TITLE",
    "text": "Respondent Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المستجيب"
      }
    ]
  },
  {
    "key": "AP_T_34_DESCRIPTION",
    "text": "Invite respondents to share their feedback on the completed initiative to evaluate its effectiveness and overall impact.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بدعوة المستجيبين لتقديم ملاحظاتهم حول المبادرة المكتملة لمعرفة مدى فعاليتها."
      }
    ]
  },
  {
    "key": "AP_T_35_TITLE",
    "text": "Time Frame",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_T_35_DESCRIPTION",
    "text": "In Timeframe, you set the feedback deadline in addition to automated reminders.\nNote: you can add up to three reminders",
    "translations": [
      {
        "language": "AR",
        "text": "في \"المدة الزمنية\"، يمكنك تحديد الإطار الزمني لتقديم ملاحظاتهم بالإضافة إلى تذكيرات تلقائية.\nتلميح: يمكنك إضافة ما يصل إلى ثلاثة رسائل تذكير."
      }
    ]
  },
  {
    "key": "AP_T_36_TITLE",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني"
      }
    ]
  },
  {
    "key": "AP_T_36_DESCRIPTION",
    "text": "Customize the email template sent or use the default template generated by Zenithr.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج الإيميل أو استخدم النموذج الأساسي المُعرف من زينيثر."
      }
    ]
  },
  {
    "key": "AP_T_37_TITLE",
    "text": "Send Invite",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      }
    ]
  },
  {
    "key": "AP_T_37_DESCRIPTION",
    "text": "Click Send Now to share the invitations with respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على إرسال الآن لمشاركة الدعوات مع المستجيبين."
      }
    ]
  },
  {
    "key": "AP_T_38_TITLE",
    "text": "Live Analytics",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات اللحظية"
      }
    ]
  },
  {
    "key": "AP_T_38_DESCRIPTION",
    "text": "Monitor real-time responses and track participation as feedback is submitted.\nNote: A minimum of three responses is required to close the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "تابع الردود بشكل فوري وراقب مستوى المشاركة لحظة بلحظة مع وصول الملاحظات.\nتلميح: يتطلب إغلاق الاستبيان ثلاثة ردود على الأقل."
      }
    ]
  },
  {
    "key": "AP_T_39_TITLE",
    "text": "Result View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض النتائج"
      }
    ]
  },
  {
    "key": "AP_T_39_DESCRIPTION",
    "text": "Click View Results to see responses, overall rating, and response distribution to quickly evaluate the initiative’s impact and effectiveness",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على عرض النتائج للاطلاع على الردود، التقييم العام، وتوزيع المشاركات لتقييم أثر المبادرة وفعاليتها بسرعة."
      }
    ]
  },
  {
    "key": "AP_T_40_TITLE",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "AP_T_40_DESCRIPTION",
    "text": "Easily showcase your progress! Click “Export” to save and share your initiatives, tasks, feedback, and live dashboard data as a PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض تقدم خطة العمل بكل سهولة! انقر على \"تحميل\" لحفظ ومشاركة المبادرات والمهام وملاحظات الموظفين وبيانات لوحة التحكم المباشرة بصيغة PDF."
      }
    ]
  },
  {
    "key": "AP_S_T_1_TITLE",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_1_DESCRIPTION",
    "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to boost employee wellbeing.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة خطة العمل، يتم تحويل ملاحظات الموظفين إلى مبادرات واضحة وقابلة للتنفيذ. هنا يمكنك إنشاء خطتك، إعدادها، وإطلاقها لتعزيز مستوى الرفاهية الوظيفية."
      }
    ]
  },
  {
    "key": "AP_S_T_2_TITLE",
    "text": "Create Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_2_DESCRIPTION",
    "text": "After selecting an entity or choosing company-wide, click New Action Plan in the center to get started, or use the top-right button.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد تحديد وحدة معيّنة أو اختيار مستوى الشركة بالكامل، انقر على خطة عمل جديدة في وسط الشاشة للبدء، أو استخدم الزر الموجود في أعلى اليسار."
      }
    ]
  },
  {
    "key": "AP_S_T_3_TITLE",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      }
    ]
  },
  {
    "key": "AP_S_T_3_DESCRIPTION",
    "text": "Click here to filter and create an action plan for a selected entity or company-wide.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط هنا لاستخدام الفلاتر وإنشاء خطة عمل لجهة محددة أو على مستوى الشركة بالكامل."
      }
    ]
  },
  {
    "key": "AP_S_T_4_TITLE",
    "text": "Entity Selection – by Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الوحدة - جهة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_4_DESCRIPTION",
    "text": "Select the desired entity for your action plan by checking its box, then click Apply.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة المطلوبة لخطة العمل الخاصة بك عن طريق تحديد المربع بجانبها، ثم اضغط على تطبيق."
      }
    ]
  },
  {
    "key": "AP_S_T_5_TITLE",
    "text": "Action Plan List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة خطط العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_5_DESCRIPTION",
    "text": "The action plan list displays all created action plans, showing their scope along with the number of focus areas, initiatives, and tasks.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض قائمة خطط العمل جميع الخطط التي تم إنشاؤها، موضحة نطاق كل منها وعدد مجالات التركيز والمبادرات والمهام."
      }
    ]
  },
  {
    "key": "AP_S_T_6_TITLE",
    "text": "Edit Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل خطط العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_6_DESCRIPTION",
    "text": "Edit or delete the action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف خطط العمل."
      }
    ]
  },
  {
    "key": "AP_S_T_7_TITLE",
    "text": "Accessing Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "الوصول إلى خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_7_DESCRIPTION",
    "text": "To access an action plan, click Open.",
    "translations": [
      {
        "language": "AR",
        "text": "للوصول إلى خطة العمل، اضغط على فتح."
      }
    ]
  },
  {
    "key": "AP_S_T_8_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_S_T_8_DESCRIPTION",
    "text": "Give your plan a clear, descriptive name to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "امنح خطتك عنوانًا واضحًا للبدء."
      }
    ]
  },
  {
    "key": "AP_S_T_9_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_S_T_9_DESCRIPTION",
    "text": "Add a brief description to explain the purpose and focus of your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف وصفًا موجزًا لشرح هدف وتركيز لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_S_T_10_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "AP_S_T_10_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      }
    ]
  },
  {
    "key": "AP_S_T_11_TITLE",
    "text": "Scope",
    "translations": [
      {
        "language": "AR",
        "text": "النطاق"
      }
    ]
  },
  {
    "key": "AP_S_T_11_DESCRIPTION",
    "text": "The “Scope” shows whether the action plan is applied organization-wide or to a specific business level.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض \"النطاق\" ما إذا كانت خطة العمل تنطبق على المنظمة بأكملها أو على مستوى عمل محدد."
      }
    ]
  },
  {
    "key": "AP_S_T_12_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة"
      }
    ]
  },
  {
    "key": "AP_S_T_12_DESCRIPTION",
    "text": "Choose the start and end dates for your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر تاريخ البدء وتاريخ الانتهاء لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_S_T_13_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_13_DESCRIPTION",
    "text": "Once everything looks good, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد التأكد من أن كل شيء يبدو على ما يرام، اضغط على \"التالي\" للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_14_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_14_DESCRIPTION",
    "text": "Select key dimensions or topics based on low scores and employee feedback to drive targeted improvements.\nNote: An upward arrow (↑) signifies high organizational impact, while a downward arrow (↓) indicates low impact.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الأبعاد أو المواضيع الرئيسية بناءً على النتائج المنخفضة وملاحظات الموظفين لدعم تحسينات موجهة وفعّالة.\nتلميح: يشير السهم للأعلى (↑) إلى تأثير مرتفع على المنظمة، بينما يشير السهم للأسفل (↓) إلى تأثير منخفض."
      }
    ]
  },
  {
    "key": "AP_S_T_15_TITLE",
    "text": "Topic Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب الموضوع"
      }
    ]
  },
  {
    "key": "AP_S_T_15_DESCRIPTION",
    "text": "Topic-based Focus Areas, generated from employee comments, these topics highlight key concerns and show the number and distribution of positive, neutral, and negative comments.",
    "translations": [
      {
        "language": "AR",
        "text": "في مجالات التركيز حسب الموضوع، يتم إنشاء المواضيع من تعليقات الموظفين، حيث تسلط الضوء على أبرز الاهتمامات وتعرض عدد وتوزيع التعليقات الإيجابية والمحايدة والسلبية."
      }
    ]
  },
  {
    "key": "AP_S_T_16_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_16_DESCRIPTION",
    "text": "Once you’re satisfied with the selected focus areas, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد التأكد من مجالات التركيز المختارة، اضغط على “التالي” للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_17_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_17_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your initiatives!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المبادرات المناسبة!"
      }
    ]
  },
  {
    "key": "AP_S_T_18_TITLE",
    "text": "Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      }
    ]
  },
  {
    "key": "AP_S_T_18_DESCRIPTION",
    "text": "Select your focus area and choose the desired initiative by checking the box next to it.\nNote: predefined initiatives cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر مجال التركيز، ثم حدّد المبادرة المربع بجانبها.\nملاحظة: لا يمكن تعديل المبادرات المعرفة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_S_T_19_TITLE",
    "text": "Custom Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "مبادرة مخصصة"
      }
    ]
  },
  {
    "key": "AP_S_T_19_DESCRIPTION",
    "text": "You can also add initiatives manually.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك أيضًا إضافة المبادرات يدويًا."
      }
    ]
  },
  {
    "key": "AP_S_T_20_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_S_T_20_DESCRIPTION",
    "text": "Fill in your \"Initiative Title\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان المبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_21_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_S_T_21_DESCRIPTION",
    "text": "Fill in your \" Initiative Description\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة وصف المبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_22_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_S_T_22_DESCRIPTION",
    "text": "Set the due date for your initiative.\nNote: The due date cannot be later than the overall action plan due date.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ الإكمال المبادرة.\nتلميح: لا يمكن أن يكون تاريخ الإكمال للمبادرة بعد تاريخ إكمال خطة العمل الإجمالي."
      }
    ]
  },
  {
    "key": "AP_S_T_23_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_S_T_23_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nNote: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_24_TITLE",
    "text": "AI-Generated Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_S_T_24_DESCRIPTION",
    "text": "Generate initiatives effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المبادرات بسهولة بالضغط على“✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      }
    ]
  },
  {
    "key": "AP_S_T_25_TITLE",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      }
    ]
  },
  {
    "key": "AP_S_T_25_DESCRIPTION",
    "text": "You can update your initiative details, such as the owner and the due date, by clicking on the three vertical dots.\nNote: You can edit the title and the description of the custom initiative as well.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث تفاصيل المبادرة، مثل المسؤول وتاريخ الاستحقاق، من خلال النقر على النقاط الرأسية الثلاث.\nملاحظة: يمكنك أيضًا تعديل عنوان المبادرة المخصصة ووصفها."
      }
    ]
  },
  {
    "key": "AP_S_T_26_TITLE",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "مسح"
      }
    ]
  },
  {
    "key": "AP_S_T_26_DESCRIPTION",
    "text": "You can delete any initiative by clicking on the three vertical dots",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك مسح المبادرة بالضغط على النقاط الرأسية الثلاث."
      }
    ]
  },
  {
    "key": "AP_S_T_27_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_27_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرات، اضغط على \"التالي\" للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_28_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_28_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your tasks!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المهام المناسبة!"
      }
    ]
  },
  {
    "key": "AP_S_T_29_TITLE",
    "text": "Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_29_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, choose the desired tasks by checking the box next to it.\nHint: Predefined tasks cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرة، حدِّد المهام بوضع علامة في المربع المجاور لها.\nتلميح: لا يمكن تعديل المهام المحددة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_S_T_30_TITLE",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة المهام يدويًا"
      }
    ]
  },
  {
    "key": "AP_S_T_30_DESCRIPTION",
    "text": "Add customized tasks based on your specific needs.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء مهام مخصصة وفقًا لاحتياجاتك."
      }
    ]
  },
  {
    "key": "AP_S_T_31_TITLE",
    "text": "Edit Task",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_31_DESCRIPTION",
    "text": "You can update the task by clicking on the pen icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث المهمة بالنقر على أيقونة القلم."
      }
    ]
  },
  {
    "key": "AP_S_T_32_TITLE",
    "text": "Delete Task",
    "translations": [
      {
        "language": "AR",
        "text": "مسح المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_32_DESCRIPTION",
    "text": "You can delete any task by clicking on the delete icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك مسح أي مهمة بالنقر على أيقونة المسح."
      }
    ]
  },
  {
    "key": "AP_S_T_33_TITLE",
    "text": "AI- Generated Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_S_T_33_DESCRIPTION",
    "text": "Generate tasks effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your initiative!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المهام بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة للمبادرة!"
      }
    ]
  },
  {
    "key": "AP_S_T_34_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_S_T_34_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nHint: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_35_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_35_DESCRIPTION",
    "text": "Once you’ve selected your tasks, click Next to continue.\nNote: each initiative must have at least 1 task and 1 owner",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المهام، اضغط على التالي للمتابعة.\nملاحظة: يجب أن تحتوي كل مبادرة على مهمة واحدة على الأقل ومالك واحد"
      }
    ]
  },
  {
    "key": "AP_S_T_36_TITLE",
    "text": "Action Plan Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_36_DESCRIPTION",
    "text": "Review your full action plan, including focus areas, initiatives, tasks, owners, and timelines—all in one place before launching.",
    "translations": [
      {
        "language": "AR",
        "text": "راجع تفاصيل خطة العمل بما في ذلك مجالات التركيز والمبادرات والمهام والمسؤولين والجداول الزمنية."
      }
    ]
  },
  {
    "key": "AP_S_T_37_TITLE",
    "text": "Launch",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق"
      }
    ]
  },
  {
    "key": "AP_S_T_37_DESCRIPTION",
    "text": "Once everything is set, click Launch to make your action plan live.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد الانتهاء من الإعدادات، اضغط على إطلاق لبدء خطة العمل."
      }
    ]
  },
  {
    "key": "AP_S_T_38_TITLE",
    "text": "Tracking",
    "translations": [
      {
        "language": "AR",
        "text": "التتبع"
      }
    ]
  },
  {
    "key": "AP_S_T_38_DESCRIPTION",
    "text": "View overall progress, task status, and key details such as Focus Areas, Initiatives, dates, and time remaining at a glance.",
    "translations": [
      {
        "language": "AR",
        "text": "اعرض التقدم العام، حالة المهام، والتفاصيل الأساسية مثل مجالات التركيز والمبادرات والتواريخ والوقت المتبقي بنظرة سريعة."
      }
    ]
  },
  {
    "key": "AP_S_T_39_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_39_DESCRIPTION",
    "text": "Here you view the selected Focus Areas, whether Topics or Dimensions.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض مجالات التركيز المختارة، سواء كانت مواضيع أو الأبعاد."
      }
    ]
  },
  {
    "key": "AP_S_T_40_TITLE",
    "text": "Tasks Management",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_40_DESCRIPTION",
    "text": "Mark individual tasks as done using the checkbox or finish all at once with Mark All as Complete.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المهام الفردية كمكتملة باستخدام المربع، أو قم بإكمال جميع المهام بالضغط على تحديد الكل كمكتمل."
      }
    ]
  },
  {
    "key": "AP_S_T_41_TITLE",
    "text": "Status Filter",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب الحالة"
      }
    ]
  },
  {
    "key": "AP_S_T_41_DESCRIPTION",
    "text": "You can filter initiatives by status: In Progress, Completed, or Expired.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك فرز المبادرات حسب الحالة: قيد التنفيذ مكتملة، أو منتهية."
      }
    ]
  },
  {
    "key": "AP_S_T_42_TITLE",
    "text": "Request for Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "طلب ملاحظات"
      }
    ]
  },
  {
    "key": "AP_S_T_42_DESCRIPTION",
    "text": "Click “Request Feedback” to invite employees to share their opinions and experiences regarding the implemented initiative, and measure its impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على طلب ملاحظات لدعوة الموظفين لمشاركة آرائهم وتجاربهم حول المبادرة المنفذة وقياس أثرها."
      }
    ]
  },
  {
    "key": "AP_S_T_43_TITLE",
    "text": "Respondent Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المستجيب"
      }
    ]
  },
  {
    "key": "AP_S_T_43_DESCRIPTION",
    "text": "Invite respondents to share their feedback on the completed initiative to evaluate its effectiveness and overall impact.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بدعوة المستجيبين لتقديم ملاحظاتهم حول المبادرة المكتملة لمعرفة مدى فعاليتها."
      }
    ]
  },
  {
    "key": "AP_S_T_44_TITLE",
    "text": "Time Frame",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_S_T_44_DESCRIPTION",
    "text": "In Timeframe, you set the feedback deadline in addition to automated reminders.\nHint: you can add up to three reminders",
    "translations": [
      {
        "language": "AR",
        "text": "في \"المدة الزمنية\"، يمكنك تحديد الإطار الزمني لتقديم ملاحظاتهم بالإضافة إلى تذكيرات تلقائية.\nتلميح: يمكنك إضافة ما يصل إلى ثلاثة رسائل تذكير."
      }
    ]
  },
  {
    "key": "AP_S_T_45_TITLE",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني"
      }
    ]
  },
  {
    "key": "AP_S_T_45_DESCRIPTION",
    "text": "Customize the email template sent or use the default template generated by Zenithr.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج الإيميل أو استخدم النموذج الأساسي المُعرف من زينيثر."
      }
    ]
  },
  {
    "key": "AP_S_T_46_TITLE",
    "text": "Send Invite",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      }
    ]
  },
  {
    "key": "AP_S_T_46_DESCRIPTION",
    "text": "Click Send Now to share the invitations with respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على إرسال الآن لمشاركة الدعوات مع المستجيبين."
      }
    ]
  },
  {
    "key": "AP_S_T_47_TITLE",
    "text": "Live Analytics",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات اللحظية"
      }
    ]
  },
  {
    "key": "AP_S_T_47_DESCRIPTION",
    "text": "Monitor real-time responses and track participation as feedback is submitted.\nHint: Minimum of three responses is required to close the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "تابع الردود بشكل فوري وراقب مستوى المشاركة لحظة بلحظة مع وصول الملاحظات.\nتلميح: يتطلب إغلاق الاستبيان ثلاثة ردود على الأقل."
      }
    ]
  },
  {
    "key": "AP_S_T_48_TITLE",
    "text": "Result View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض النتائج"
      }
    ]
  },
  {
    "key": "AP_S_T_48_DESCRIPTION",
    "text": "Click View Results to see responses, overall rating, and response distribution to quickly evaluate the initiative’s impact and effectiveness",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على عرض النتائج للاطلاع على الردود، التقييم العام، وتوزيع المشاركات لتقييم أثر المبادرة وفعاليتها بسرعة."
      }
    ]
  },
  {
    "key": "AP_S_T_49_TITLE",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "AP_S_T_49_DESCRIPTION",
    "text": "Easily showcase your progress! Click “Export” to save and share your initiatives, tasks, feedback, and live dashboard data as a PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض تقدم خطة العمل بكل سهولة! انقر على \"تحميل\" لحفظ ومشاركة المبادرات والمهام وملاحظات الموظفين وبيانات لوحة التحكم المباشرة بصيغة PDF."
      }
    ]
  },
  {
    "key": "ORG_T_1_TITLE",
    "text": "Org chart",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      }
    ]
  },
  {
    "key": "ORG_T_1_DESCRIPTION",
    "text": "In the \"Org chart\" page, you can explore your organization's structure — whether by function or position — and see how each level is performing at a glance, making it easier to spot strengths and areas for growth.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة \"الهيكل التنظيمي\"، يمكنك استعراض هيكل مؤسستك — سواء التنظيمي أو الوظيفي — والاطّلاع على أداء كل مستوى بنظرة واحدة، مما يسهّل عليك تحديد نقاط القوة وفرص التطوير."
      }
    ]
  },
  {
    "key": "ORG_T_2_TITLE",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "البحث"
      }
    ]
  },
  {
    "key": "ORG_T_2_DESCRIPTION",
    "text": "Quickly find what you need using the search bar — search by entity or superior and navigate directly to the right spot in your org chart.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم شريط البحث للوصول السريع إلى ما تحتاجه — ابحث حسب الوحدة أو المسؤول المباشر وانتقل فورًا إلى موقعه في الهيكل التنظيمي."
      }
    ]
  },
  {
    "key": "ORG_T_3_TITLE",
    "text": "Zoom In",
    "translations": [
      {
        "language": "AR",
        "text": "تكبير العرض"
      }
    ]
  },
  {
    "key": "ORG_T_3_DESCRIPTION",
    "text": "Zoom in to take a closer look at specific areas of your organization's structure.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتكبير العرض لإلقاء نظرة أقرب على مناطق محددة في الهيكل التنظيمي."
      }
    ]
  },
  {
    "key": "ORG_T_4_TITLE",
    "text": "Zoom Out",
    "translations": [
      {
        "language": "AR",
        "text": "تصغير العرض"
      }
    ]
  },
  {
    "key": "ORG_T_4_DESCRIPTION",
    "text": "Zoom out to see the bigger picture of your organization's structure.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتصغير العرض لرؤية الصورة الأشمل لهيكل مؤسستك."
      }
    ]
  },
  {
    "key": "ORG_T_5_TITLE",
    "text": "Collapse",
    "translations": [
      {
        "language": "AR",
        "text": "طيّ"
      }
    ]
  },
  {
    "key": "ORG_T_5_DESCRIPTION",
    "text": "Collapse the entire org chart at once to reset the view and start fresh from the top level.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بطي الهيكل التنظيمي بالكامل لإعادة ضبط العرض والبدء من المستوى الأعلى."
      }
    ]
  },
  {
    "key": "ORG_T_6_TITLE",
    "text": "Expand",
    "translations": [
      {
        "language": "AR",
        "text": "توسيع"
      }
    ]
  },
  {
    "key": "ORG_T_6_DESCRIPTION",
    "text": "Want to see the full picture? Expand the org chart to reveal all levels and details across your organization.",
    "translations": [
      {
        "language": "AR",
        "text": "هل تريد رؤية الصورة الكاملة؟ قم بتوسيع الهيكل التنظيمي لاستعراض جميع المستويات والتفاصيل في مؤسستك."
      }
    ]
  },
  {
    "key": "ORG_T_7_TITLE",
    "text": "Fullscreen",
    "translations": [
      {
        "language": "AR",
        "text": "ملء الشاشة"
      }
    ]
  },
  {
    "key": "ORG_T_7_DESCRIPTION",
    "text": "Switch to full-screen mode for a wider, more immersive view of your org chart.",
    "translations": [
      {
        "language": "AR",
        "text": "انتقل إلى وضع ملء الشاشة للحصول على عرض أوسع وأشمل للهيكل التنظيمي."
      }
    ]
  },
  {
    "key": "ORG_T_8_TITLE",
    "text": "Center",
    "translations": [
      {
        "language": "AR",
        "text": "التمركز"
      }
    ]
  },
  {
    "key": "ORG_T_8_DESCRIPTION",
    "text": "Click here to re-center the org chart and bring it back to the default view.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على أيقونة التمركز لإعادة الهيكل التنظيمي فورًا إلى منتصف الشاشة."
      }
    ]
  },
  {
    "key": "ORG_T_9_TITLE_1",
    "text": "Functional",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل التنظيمي"
      }
    ]
  },
  {
    "key": "ORG_T_9_DESCRIPTION_1",
    "text": "View your org chart by function to see how your entities are structured and how employee well-being scores are distributed across them, giving you a clear picture of performance at every level of your organization.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض الهيكل التنظيمي حسب الإدارات لترى كيف يتم تنظيم الوحدات داخل مؤسستك وكيف تتوزع درجات الرفاهية بينها، مما يمنحك صورة واضحة عن الأداء على مختلف مستويات المؤسسة."
      }
    ]
  },
  {
    "key": "ORG_T_9_TITLE_2",
    "text": "Positional",
    "translations": [
      {
        "language": "AR",
        "text": "الهيكل الوظيفي"
      }
    ]
  },
  {
    "key": "ORG_T_9_DESCRIPTION_2",
    "text": "Switch to the positional view to explore the org chart based on superiors and their teams, helping you understand well-being dynamics at the team level and identify where leadership is making an impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انتقل إلى العرض حسب الهيكل الوظيفي لعرض أداء كل مدير مباشر والفريق التابع له. يمكنك من خلاله فهم مستويات الرفاهية على مستوى الفرق، وتحديد مدى تأثير القيادة على النتائج."
      }
    ]
  },
  {
    "key": "ORG_T_10_TITLE",
    "text": "Customize View",
    "translations": [
      {
        "language": "AR",
        "text": "تخصيص العرض"
      }
    ]
  },
  {
    "key": "ORG_T_10_DESCRIPTION",
    "text": "Customize your view by changing the layout, displaying key analysis, or selecting a specific dimension to explore deeper insights.\nNote: A maximum of 3 options can be selected",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتغيير طريقة عرض النتائج من خلال تعديل التخطيط، أو إظهار أبرز التحليلات، أو اختيار بعد محدد للتعمّق في التحليلات.\nملاحظة: يمكن اختيار 3 خيارات كحد أقصى."
      }
    ]
  },
  {
    "key": "ORG_T_11_TITLE",
    "text": "Entity Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل الوحدات"
      }
    ]
  },
  {
    "key": "ORG_T_11_TITLE_P",
    "text": "Superior Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل المدراء"
      }
    ]
  },
  {
    "key": "ORG_T_11_DESCRIPTION",
    "text": "Click on any entity to dive into its detailed well-being insights — view its overall scores, see how it compares to the organization's average, and track historical trends to understand how well-being has evolved.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على أي وحدة للاطّلاع على تفاصيل الرفاهية الخاصة بها، بما في ذلك درجة الرفاهية الكلية، ومقارنتها بمتوسط المؤسسة وتتبع تطورها."
      }
    ]
  },
  {
    "key": "ORG_T_11_DESCRIPTION_P",
    "text": "Click on any superior to dive into its detailed team well-being insights — view its overall scores, see how it compares to the organization's average, and track historical trends to understand how well-being has evolved.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على أي مدير للاطّلاع على تفاصيل الرفاهية الخاصة بالفريق التابع له، بما في ذلك درجة الرفاهية الكلية، ومقارنتها بمتوسط المؤسسة، وتتبّع تطوّرها."
      }
    ]
  },
  {
    "key": "ORG_T_12_TITLE",
    "text": "Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة"
      }
    ]
  },
  {
    "key": "ORG_T_12_DESCRIPTION",
    "text": "See how your entities stack up against each other. Use Multi-Compare to compare well-being scores across multiple entities at once, or Peer-to-Peer to put two entities side by side by checking the boxes — making it easy to spot differences and take action.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف كيف تتفاوت الوحدات فيما بينها. استخدم المقارنة المتعددة لمقارنة درجات الرفاهية بين عدة وحدات دفعة واحدة، أو المقارنة بين وحدتين لوضع وحدتين وجهًا لوجه من خلال تحديد المربعات — مما يسهّل عليك رصد الفروقات واتخاذ الإجراء المناسب."
      }
    ]
  },
  {
    "key": "ORG_T_12_DESCRIPTION_P",
    "text": "See how your superior teams stack up against each other. Use Multi-Compare to compare well-being scores across multiple superiors at once, or Peer-to-Peer to put two superiors' side by side by checking the boxes, making it easy to spot differences and take action.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف كيف تتفاوت درجات الرفاهية بين فرق المدراء المختلفة. استخدم المقارنة المتعددة لمقارنة درجات الرفاهية بين المدراء دفعة واحدة، أو المقارنة بين مديرين لوضع المدراء وجهًا لوجه من خلال تحديد المربعات — مما يسهّل عليك رصد الفروقات واتخاذ الإجراء المناسب."
      }
    ]
  },
  {
    "key": "ORG_T_13_TITLE",
    "text": "Peer-to-Peer Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة بين وحدتين"
      }
    ]
  },
  {
    "key": "ORG_T_13_TITLE_P",
    "text": "Peer-to-Peer Comparison",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة بين مديرين"
      }
    ]
  },
  {
    "key": "ORG_T_13_DESCRIPTION",
    "text": "Easily spot differences in well-being scores and key dimensions between entities — all displayed side by side.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف الفروقات في درجات الرفاهية والأبعاد الرئيسية بين الوحدات بسهولة — معروضة جنبًا إلى جنب."
      }
    ]
  },
  {
    "key": "ORG_T_13_DESCRIPTION_P",
    "text": "Easily spot differences in well-being on scores and key dimensions between superiors — all displayed side by side.",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف الفروقات في درجات الرفاهية والأبعاد الرئيسية بين المدراء والفرق التابعة لهم بسهولة — معروضة جنبًا إلى جنب."
      }
    ]
  },
  {
    "key": "ORG_T_14_TITLE",
    "text": "Change Entities",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير الوحدات"
      }
    ]
  },
  {
    "key": "ORG_T_14_TITLE_P",
    "text": "Change Superiors",
    "translations": [
      {
        "language": "AR",
        "text": "تغيير المدراء"
      }
    ]
  },
  {
    "key": "ORG_T_14_DESCRIPTION",
    "text": "Use the dropdown to switch entities and explore different entity comparisons.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم القائمة المنسدلة لتغيير الوحدات واستعراض مقارنات مختلفة بين الوحدات."
      }
    ]
  },
  {
    "key": "ORG_T_14_DESCRIPTION_P",
    "text": "Use the dropdown to switch between superiors and explore different superior teams' comparisons.",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم القائمة المنسدلة لتغيير المدراء واستعرض المقارنات بين الفرق التابعة لهم."
      }
    ]
  },
  {
    "key": "ORG_T_15_TITLE",
    "text": "Peer-to-Peer Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة بين الوحدتين"
      }
    ]
  },
  {
    "key": "ORG_T_15_TITLE_P",
    "text": "Peer-to-Peer Comparison Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة بين مديرين"
      }
    ]
  },
  {
    "key": "ORG_T_15_DESCRIPTION",
    "text": "Download the peer-to-peer comparison report to easily review or share the comparison results.\nNote: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل تقرير المقارنة بين وحدتين لمراجعة نتائج المقارنة أو مشاركتها بسهولة.\nملحوظة: متوفر في صيغة PDF."
      }
    ]
  },
  {
    "key": "ORG_T_15_DESCRIPTION_P",
    "text": "Download the peer-to-peer comparison report to easily review or share the comparison results.\nNote: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل تقرير المقارنة بين مديرين لمراجعة نتائج المقارنة أو مشاركتها بسهولة.\nملحوظة: متوفر في صيغة PDF."
      }
    ]
  },
  {
    "key": "ORG_T_16_TITLE",
    "text": "Multi Compare",
    "translations": [
      {
        "language": "AR",
        "text": "المقارنة المتعددة"
      }
    ]
  },
  {
    "key": "ORG_T_16_DESCRIPTION",
    "text": "Compare scores across multiple entities and see how they perform against the organization's overall results.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن درجات الرفاهية عبر عدة وحدات واطّلع على أدائها مقارنة بالنتائج الكلية للمؤسسة."
      }
    ]
  },
  {
    "key": "ORG_T_16_DESCRIPTION_P",
    "text": "Compare scores across multiple superiors and see how they perform against the organization's overall results.",
    "translations": [
      {
        "language": "AR",
        "text": "قارن النتائج بين المدراء والفرق التابعة لهم واطّلع على أدائهم مقارنة بالنتائج الكلية للمؤسسة."
      }
    ]
  },
  {
    "key": "ORG_T_17_TITLE",
    "text": "Sorting",
    "translations": [
      {
        "language": "AR",
        "text": "الترتيب"
      }
    ]
  },
  {
    "key": "ORG_T_17_DESCRIPTION",
    "text": "Sort entity scores in ascending or descending order to quickly identify your top and lowest well-being entities.",
    "translations": [
      {
        "language": "AR",
        "text": "رتّب نتائج الوحدات تصاعديًا أو تنازليًا لتحديد الوحدات الأعلى والأقل رفاهية."
      }
    ]
  },
  {
    "key": "ORG_T_17_DESCRIPTION_P",
    "text": "Sort superior team scores in ascending or descending order to quickly identify your top and lowest well-being superiors.",
    "translations": [
      {
        "language": "AR",
        "text": "رتّب نتائج فرق المدراء تصاعديًا أو تنازليًا لتحديد المدراء الأعلى والأقل رفاهية."
      }
    ]
  },
  {
    "key": "ORG_T_18_TITLE",
    "text": "Dimension Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الأبعاد"
      }
    ]
  },
  {
    "key": "ORG_T_18_DESCRIPTION",
    "text": "Go beyond the overall scores, select a specific well-being dimension to see how your entities are scoring on each area of well-being.",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز نتائج الرفاهية الكلية واختر بعدًا محددًا للرفاهية لمعرفة درجات الوحدات في كل بعد من أبعاد رفاهية الموظف."
      }
    ]
  },
  {
    "key": "ORG_T_18_DESCRIPTION_P",
    "text": "Go beyond the overall scores, select a specific well-being dimension to see how your superior teams are scoring on each area of well-being.",
    "translations": [
      {
        "language": "AR",
        "text": "تجاوز نتائج الرفاهية الكلية واختر بعدًا محددًا للرفاهية لمعرفة درجات فرق المدراء في كل بعد من الرفاهية."
      }
    ]
  },
  {
    "key": "ORG_T_20_TITLE",
    "text": "Multi-Compare Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير المقارنة المتعددة"
      }
    ]
  },
  {
    "key": "ORG_T_20_DESCRIPTION",
    "text": "Download the multi-compare report to easily review or share the comparison results.\nNote: Available in PDF format.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتحميل تقرير المقارنة المتعددة لمراجعة نتائج المقارنة أو مشاركتها بسهولة.\nملحوظة: متوفر في صيغة PDF."
      }
    ]
  }
]